class ChatClient {

    constructor(pubSub, connectionManager, chatLanguage, config, chatWrapper) {
        this.chatWrapper = chatWrapper;
        this.pubSub = pubSub;
        this.config = config;
        this.connectionManager = connectionManager;
        this.INIT_ROOM = null;
        this.ANIMATION_SPEED = 250;
        this.MAX_CHAT_TEXT_LENGTH = 1000;
        this.MAX_EMOJIES = 10;
        this.SETTINGS = {
            roomBase: 'conference',
            resources: '/services/chat',
            session: 'xmpplocalusersession',
            ajaxScript: {
                blockUser: "/services/user/block",
                userProfile: this.config.profileBaseLink,
                friendRequest: "/services/user/friends/request-friendship",
                chatAdmin: "/services/admin/chat-admin",
                getUser: "/services/chat/user"
            }
        };
        this.ignoredUsers = [];

        this.language = {
            all: chatLanguage.getAll(),
            writeMessageHere:
                chatLanguage.getText('F02'),
            pressEnterToSend:
                chatLanguage.getText('F03'),
            noConnection:
                chatLanguage.getText('F04'),
            lastMessageReceivedAt:
                chatLanguage.getText('F05'),
            isTypingAMessage:
                chatLanguage.getText('F06'),
            joinedTheRoom:
                chatLanguage.getText('F07'),
            leftTheRoom:
                chatLanguage.getText('F08'),
            userList:
                chatLanguage.getText('F09'),
            friendsList:
                chatLanguage.getText('F84'),
            roomList:
                chatLanguage.getText('F10'),
            settings:
                chatLanguage.getText('F11'),
            yourFriend:
                chatLanguage.getText('F12'),
            yourFriends:
                chatLanguage.getText('F53'),
            and:
                chatLanguage.getText('F13'),
            isAlsoInThisRoom:
                chatLanguage.getText('F14'),
            kick:
                chatLanguage.getText('F26'),
            ban:
                chatLanguage.getText('F28'),
            reason:
                chatLanguage.getText('F31'),
            room:
                chatLanguage.getText('F37'),
            chatIcon:
                chatLanguage.getText('F38'),
            back:
                chatLanguage.getText('F39'),
            sentTooManyMessages:
                chatLanguage.getText('F44'),
            instantUserMessage:
                chatLanguage.getText('F151'),
            youCanSendMessagesAgain:
                chatLanguage.getText('F45'),
            getSharedPrize:
                chatLanguage.getText('F48'),
            roomIsFull:
                chatLanguage.getText('F49'),
            pleaseWait:
                chatLanguage.getText('F50'),
            prizePaid:
                chatLanguage.getText('F51'),
            says:
                chatLanguage.getText('F54'),
            youHaveBeenBanned:
                chatLanguage.getText('F55'),
            newChatVersionAvailable:
                chatLanguage.getText('F56'),
            update:
                chatLanguage.getText('F57'),
            youHaveBeenMuted:
                chatLanguage.getText('F82'),
            youAreNowIn:
                chatLanguage.getText('F85'),
            rightNow:
                chatLanguage.getText('F86'),
            aMinuteAgo:
                chatLanguage.getText('F87'),
            minutesAgo:
                chatLanguage.getText('F88'),
            anHourAgo:
                chatLanguage.getText('F89'),
            hoursAgo:
                chatLanguage.getText('F90'),
            aDayAgo:
                chatLanguage.getText('F91'),
            daysAgo:
                chatLanguage.getText('F92'),
            close:
                chatLanguage.getText('F95'),
            edit:
                chatLanguage.getText('F96'),
            directChat:
                chatLanguage.getText('F83'),
            users:
                chatLanguage.getText('F98'),
            chatRooms:
                chatLanguage.getText('F99'),
            searchInFriendList:
                chatLanguage.getText('F101'),
            selectReceiver:
                chatLanguage.getText('F104'),
            yesterday:
                chatLanguage.getText('F105'),
            at:
                chatLanguage.getText('F107'),
            areYouSure:
                chatLanguage.getText('F109'),
            ok:
                chatLanguage.getText('F110'),
            cancel:
                chatLanguage.getText('F111'),
            search:
                chatLanguage.getText('F112'),
            startConversationWith:
                chatLanguage.getText('F113'),
            'delete':
                chatLanguage.getText('F114'),
            notifications:
                chatLanguage.getText('F115'),
            congratulate:
                chatLanguage.getText('F116'),
            congratulations:
                chatLanguage.getText('F117'),
            congratulationsAndThankYou:
                chatLanguage.getText('F118'),
            isNotOnline:
                chatLanguage.getText('F120'),
            gameOpensInNewWindow:
                chatLanguage.getText('F121'),
            doYouWantToDeleteTheseMessages:
                chatLanguage.getText('F122'),
            summonAdmin:
                chatLanguage.getText('F126'),
            inviteUsers:
                chatLanguage.getText('F127'),
            anAdminHasBeenAlerted:
                chatLanguage.getText('F128'),
            thereAreErrorsInTheInput:
                chatLanguage.getText('F129'),
            invitesYouToThisChatRoom:
                chatLanguage.getText('F130'),
            createGroupChat:
                chatLanguage.getText('F131'),
            adminIsNeededIn:
                chatLanguage.getText('F132'),
            createdByYou:
                chatLanguage.getText('F133'),
            serviceFallback:
                chatLanguage.getText('F134'),
            joinThisRoom:
                chatLanguage.getText('F135'),
            startChatWith:
                chatLanguage.getText('F136'),
            hasBeenInvited:
                chatLanguage.getText('F138'),
            usernameNotAvailable:
                chatLanguage.getText('F140'),
            usernameNotValid:
                chatLanguage.getText('F141'),
            random:
                chatLanguage.getText('F142'),
            isNowCalled:
                chatLanguage.getText('F143'),
            selectAnAdmin:
                chatLanguage.getText('F144'),
            noAdminsOnline:
                chatLanguage.getText('F145'),
            chatWithAdmin:
                chatLanguage.getText('F146'),
            help:
                chatLanguage.getText('F147'),
            onlineFriends:
                chatLanguage.getText('F148')
        };

        this.MODE = undefined;
        this.MODES = {
            play: "play",
            page: "page"
        };
        this.OPTIONS = {
            namespace: "chatWhichIsClean",
            attach: false,
            maxUsers: 250,
            storage: "chatStorage"
        };

        this.chatContainer = ".CCcontainer";
        this.chatTemplates = ".CCtemplate";
        this.MAX_MESSAGES_SHOWN = 300;
        this.DISABLE_ACCOMPLISHMENTS = true;
        this.ROOMNAME = null;
        this.BASEROOM = null;
        this.OVERRIDE_SETTINGS = {};
        this.SEND_COMPOSING = true;
        this.COMPOSE_TIMER = null;
        this.AUTO_SCROLL = true;
        this.TMP_PRESENCE = [];
        this.USERS_IN_ROOM = [];
        this.FRIENDS_IN_ROOM = [];
        this.FRIENDS = {};
        this.SEARCH_OBJECT = [];
        this.SEARCH = {
            result: [],
            pointer: 0,
            startPos: 0
        };
        this.GAME = null;
        this.JOINING_ROOM = undefined;
        this.CURRENT_ROOM = null;
        this.CURRENT_PUBLIC_ROOM = undefined;
        this.JOINED_ROOMS = {};
        this.SESSION_ROOMS = [];
        this.SAVED_SESSION_ROOMS = [];
        this.AVAILABLE_ROOMS = {};
        this.ROOMS_READY = false;
        this.SHOW_FRIENDS_TIMER = null;
        this.CHAT_BOT = "eventbot";
        this.PREFIX_PRIVATE_ROOM = "private-";
        this.ROOM_CREATE_TRIES = 0;
        this.ROOM_CREATE_TIMER = null;
        this.SEND_TIME = 0;
        this.MSG_COUNTER = 0;
        this.MSG_BLOCKING = false;
        this.CHAT_STATE = "groupChat";
        this.CHAT_STATES = {
            groupChat: "groupChat",
            chat: "chat",
            spilnu: "spilnu"
        };
        this.composingTimeout = [];
        this.IS_AVAILABLE = true;
    }

    setup() {
        //http://jabber.org/protocol/chatstates
        this.inputField = new InputField(this);
        this.connectionManager.addHandler(this.handleInvites.bind(this), "jabber:x:conference", "message", null);
        this.connectionManager.addHandler(this.handleEvent.bind(this), "chat:event", "message");
        this.connectionManager.addHandler(this.handleComposing.bind(this), "chatstates", "message", "chat");
        this.connectionManager.addHandler(this.handlePresence.bind(this), null, "presence");
        this.connectionManager.addHandler(this.handleRoomList.bind(this), null, "iq", null, "roomList");
        this.connectionManager.addHandler(this.handleMessage.bind(this), "chat:msg", "message");
    }

    onConnected() {
        this.loading('hide');
        if (this.CHAT_STATE !== "init" && this.connectionManager.reconnected === false) {
            this.bindEvents();
            this.DirectChat.init();
        }
        if (this.connectionManager.reconnected) {
            if (typeof this.reconnectGetAll !== "undefined") {
                clearTimeout(this.reconnectGetAll);
            }
            this.reconnectGetAll = setTimeout(() => {
                // app.ajax.get("/services/chat/get-all", {}, (data) => {
                //     for (let username in data) {
                //         const ts = parseInt($(".directChatItem[data-username='" + username + "']").find("[data-time]").eq(0).attr("data-time"));
                //         if (Number.isInteger(ts)) {
                //             if (ts !== data[username].s) {
                //                 const directChat = $("#visible-panes .pane.directChat[data-name='" + username + "']");
                //                 if (directChat.length === 1) {
                //                     this.DirectChat.loadChat(username);
                //                     this.DirectChat.updateTextInDockedChat(username, data[username].t, data[username].s, false);
                //                 } else {
                //                     app.ajax.get("/services/chat/get/" + username, {}, (messages) => {
                //                         for (let i in messages) {
                //                             if (messages[i].timestamp > ts) {
                //                                 this.DirectChat.addUnreadMessageCount(username);
                //                             }
                //                         }
                //                         this.Users.getUserObject(username, (user) => {
                //                             this.DirectChat.notify(user, data[username].t);
                //                             this.DirectChat.updateTotalUnreadMessages();
                //                             this.DirectChat.updateUnreadMessages(user.u);
                //                             this.DirectChat.updateTextInDockedChat(username, data[username].t, data[username].s, false);
                //                             app.sounds.ding();
                //                         });
                //                     });
                //                 }
                //             }
                //         } else {
                //             this.Users.getUserObject(username, (user) => {
                //                 this.DirectChat.createDockedChat(user, data[username].t, data[username].t);
                //                 this.DirectChat.notify(user, data[username].t);
                //                 this.DirectChat.addUnreadMessageCount(user.u);
                //                 this.DirectChat.updateTotalUnreadMessages();
                //                 this.DirectChat.updateUnreadMessages(user.u);
                //                 this.DirectChat.updateTextInDockedChat(username, data[username].t, data[username].s, false);
                //                 app.sounds.ding();
                //             });
                //         }
                //     }
                // });
            }, Math.round(Math.random() * 37000) + 5000);
        }
        this.connectSuccess();
    }

    onDisconnected() {
        return true;
    }

    init(chatState, roomName) {
        this.setup();
        this.setGame(roomName);
        this.UserSettings.load();
        this.setChatState(chatState, roomName + "_1");
        if (chatState === "init") {
            return;
        }
        this.loading('show');
        this.setupDeleteButtons();
        this.addTextFromLang();
        this.Emoticons.attach();
        this.setMode();
        for (let i in app.config.friends) {
            this.SEARCH_OBJECT[app.config.friends[i]] = true;
        }
        window.addEventListener("beforeunload", function (e) {
            this.leaveRoom(this.CURRENT_ROOM, true);
        }.bind(this));
    }

    checkNavButtons() {
        if (jQuery("#visible-panes .pane").length <= 1) {
            this.navIconButton("hide");
        }
        let name = jQuery("#visible-panes .pane").last().data("name");

        if (name && typeof name !== "undefined") {
            if (name.indexOf("_1") + 2 === name.length) {
                name = name.replace("_1", "");
            }
            jQuery(".title").html(name);
        }
        const att = jQuery(".writeMessageAttention", this.chatContainer);
        if (att.is(":visible")) {
            att.fadeOut(this.ANIMATION_SPEED);
        }
    }

    setMode() {
        this.MODE = (this.CHAT_STATE === this.CHAT_STATES.groupChat) ? this.MODES.play : this.MODES.page;
    }

    connectSuccess() {
        this.sendGlobalPresence();
        this.getGameList();
        this.getRoomList();
        this.addSessionRoomObjects(true);
        this.inputField.enable();
        if (this.CURRENT_ROOM === null && this.IS_AVAILABLE) {
            let waitForRooms = setInterval(() => {
                if (this.ROOMS_READY && this.ROOMNAME) {
                    clearInterval(waitForRooms);
                    this.joinNextAvailableRoom(this.ROOMNAME);
                }
            }, 50);
        } else {
            this.sendPresence(this.CURRENT_ROOM);
        }
    }

    sendPresence(roomName) {
        let p = $pres({
            to: this.getRoomJID(roomName) + "/" + this.config.user.u
        }).c("user").t(JSON.stringify(this.config.user)).tree();
        this.connectionManager.send(p);
    }

    sendUserPresence(username) {
        let p = $pres({
            to: this.getBareJID(username)
        }).c("user").t(JSON.stringify(this.config.user)).tree();
        this.connectionManager.send(p);
    }

    sendGlobalPresence() {
        let p = $pres().c("user").t(JSON.stringify(this.config.user)).tree();
        this.connectionManager.send(p);
    }

    getGameList() {
        let data = this.config.chat_games;
        for (let room in data) {
            if (typeof data[room].name === "string") {
                data[room].name = this.stripRoomNumber(data[room].name) + "_1";
                this.addRoomObject(data[room]);
            }
        }

        return true;
    }

    getRoomList() {
        this.ROOMS_READY = false;
        this.connectionManager.send($iq({
            type: "get",
            to: this.SETTINGS.roomBase + "." + this.config.domain,
            id: "roomList"
        }).c("query", {
            xmlns: "http://jabber.org/protocol/disco#items"
        }).tree());
    }

    handleRoomList(iq) {
        const roomsItems = jQuery(iq).find("item");
        let roomElement;
        for (let i = 0; i < roomsItems.length; i++) {
            roomElement = roomsItems[i];
            const name = jQuery(roomElement).attr("name");
            const roomName = name.substr(0, name.indexOf(" "));
            if (roomName === "undefined") {
                continue;
            }
            const players = parseInt(name.substr(roomName.length).replace("(", "").replace(")", "").replace(" ", ""));
            if (this.hasRoomObject(roomName)) {
                this.AVAILABLE_ROOMS[roomName].players = players;
            } else {
                if ((this.isPrivateRoom(roomName) === false && this.isHidden(roomName) === false) || (roomName === this.ROOMNAME && this.isHidden(roomName))) {
                    const roomNumber = this.getRoomNumber(roomName);
                    if (roomNumber > 1 || (roomName === this.ROOMNAME && this.isHidden(roomName))) {
                        const baseRoom = this.getRoomObject(this.stripRoomNumber(roomName) + "_1");
                        if (baseRoom !== undefined) {
                            const newRoom = $.extend(true, {}, baseRoom);
                            newRoom.name = roomName;
                            newRoom.prettyName = baseRoom.prettyName + ' - ' + roomNumber;
                            newRoom.players = players;
                            this.addRoomObject(newRoom);
                        } else {
                            this.addRoomObject({
                                name: roomName,
                                prettyName: this.prettifyRoom(roomName),
                                players: players
                            });
                        }
                    }
                }
            }
        }

        this.createRoomList();
        this.ROOMS_READY = true;

        return true;
    }

    getOnlineModeratorUsernames() {
        let list;
        $.ajax("/services/online_admins", {
            async: false,
            success: function (result) {
                list = result;
            }
        });
        return list;
    }

    /**
     *
     * {
     *     "to": "wishoff",
     *     "type": "groupchat",
     *     "from": "wishoff",
     *     "resource": "farm-empire_1",
     *     "timestamp": "1662723648195349",
     *     "text": "asd",
     *     "error": {
     *         "length": 0,
     *         "prevObject": {
     *             "0": {},
     *             "length": 1
     *         }
     *     },
     *     "hasError": false,
     *     "delayed": false,
     *     "user": {
     *         "u": "wishoff",
     *         "id": 415,
     *         "pi": "uppsruusxnsaonposo",
     *         "k": "not_specified",
     *         "d": true,
     *         "f": true,
     *         "m": null,
     *         "g": {
     *             "1": 2000,
     *             "2": 3,
     *             "3": 1,
     *             "4": 1,
     *             "11": 1,
     *             "13": 1,
     *             "14": 1,
     *             "15": 1984,
     *             "16": 1,
     *             "17": 1,
     *             "59": 1,
     *             "64": 1,
     *             "70": 1
     *         },
     *         "v": true,
     *         "b": []
     *     }
     * }
     */
    addGroupChatMessage(object) {
        const messages = document.querySelector('[data-name="' + object.resource + '"] .messageList');
        if (!messages) {
            return;
        }

        const chatLine = this.getGroupChatChatline(messages, object);
        if (chatLine) {
            messages.appendChild(chatLine);
        }
        this.scrollToBottom();
    }

    addGameAnnouncement(from, text, room) {
        if (room && this.CURRENT_ROOM && this.CURRENT_ROOM.indexOf(room) === 0) {
            this.addGroupChatMessage({"resource": this.CURRENT_ROOM, "timestamp": Date.now(), "from": "<b>" + from + "</b>", "text": text});
        }
    }

    processMessage(message) {
        message = this.WordFilter.filterBadWords(message);
        while (message.lastIndexOf(")") > this.MAX_CHAT_TEXT_LENGTH || (message.match(/\)/g) || []).length > this.MAX_EMOJIES) {
            message = message.substr(0, message.lastIndexOf("("));
        }
        message = message.substr(0, this.MAX_CHAT_TEXT_LENGTH);
        if (message.search('#C') >= 0) {
            message = "(star)(trophy)(trophy)(trophy)(trophy)(trophy)(trophy)(trophy)(trophy)(trophy)(trophy)(star)<br>" + message.replace("#C", "") + "<br>(star)(trophy)(trophy)(trophy)(trophy)(trophy)(trophy)(trophy)(trophy)(trophy)(trophy)(star)";
        }
        message = this.Emoticons.replaceIcons(message);

        if (this.UserSettings.get('highlightMyName') === true) {
            message = this.highlight(this.config.user.u, message);
        }

        return message;
    }

    getGroupChatChatline(messages, object) {
        const sig = app.util.hashCode(object.timestamp.toString().substr(0, 9) + object.from + object.text.substr(0, 16));

        if (messages.querySelector("[data-sig='" + sig + "']")) {
            return null;
        }

        let message = object.text;


        const chatLineTemplate = document.querySelector(this.chatTemplates + " > .chatLine");

        if (chatLineTemplate) {
            const chatLine = chatLineTemplate.cloneNode(true);
            const chatMessage = chatLine.querySelector(".chatMessage");
            const chatUsername = chatLine.querySelector(".username");
            let rankElement = chatLine.querySelector(".rank");
            chatUsername.innerHTML = object.from;
            chatLine.setAttribute("data-username", object.from);
            chatLine.setAttribute("data-sig", sig);
            chatLine.setAttribute("data-timestamp", object.timestamp);
            chatMessage.setAttribute("title", this.Time.timeAgo(this.language, object.timestamp));
            if (this.Users.isAdminUser(object.from)) {
                chatLine.classList.add("isModerator");
            }
            if (this.Users.isStaff(object.from)) {
                chatLine.classList.add("isStaff");
            }
            if (this.isFriend(object.from)) {
                chatLine.classList.add('isFriend');
            }
            if (object.delayed) {
                chatLine.classList.add('delayed');
            }
            if (object.text.indexOf("/me ") === 0) {
                chatLine.classList.add("meAction");
                message = message.substr(3);
                chatLine.querySelector(".rank").remove();
            } else if (object.text.indexOf("/admin ") === 0) {
                chatLine.classList.add("admin");
                message = message.substr(6);
                if (rankElement) {
                    rankElement.parentNode.removeChild(rankElement);
                    rankElement = null;
                }
            }
            if (object.resource.indexOf("private-") === 0) {
                if (rankElement) {
                    rankElement.parentNode.removeChild(rankElement);
                    rankElement = null;
                }
            }
            if (this.Users.isMe(object.from)) {
                chatUsername.classList.add("me");
            }
            if (object.user) {
                if (typeof object.user.v === "boolean" && object.user.v) {
                    chatLine.classList.add("isVip");
                }
                if (rankElement && this.UserSettings.get("showRank") === true) {
                    let rank = this.getGameRank(object.user);
                    if (rank > 0) {
                        rankElement.innerHTML = rank;
                    }
                }
                chatLine.querySelector(".username").setAttribute("gender", object.user.k);
            }
            if (message.search('#C') >= 0) {
                chatMessage.classList.add("celebration");
            }
            chatMessage.innerHTML = this.processMessage(message);
            return chatLine;
        } else {
            return null;
        }
    }

    getMessageType(object) {
        let type = '';
        if (object.text.search('/') === 0) {
            const result = object.text.match(/\/(\S*)(.*)/);
            const action = result[1];
            switch (action) {
                case 'admin':
                    type = 'admin';
                    break;
                case 'me':
                    type = 'me';
                    break;
                case 'script':
                    if (object.delayed) {
                        return true;
                    }
                    break;
                default:
            }
        }
        return type;
    }

    addDirectChatMessage(from, to, message, timestamp) {
        if (!this.config.user.d && !this.Users.isAdminUser(from) && !this.Users.isMe(from)) {
            return true;
        }
        this.Users.getUserObject(from, (user) => {
            if (user.u === undefined) {
                return true;
            }
            if (this.Users.isMe(from)) {
                this.DirectChat.updateTextInDockedChat(to, this.escapeHTML(message), timestamp, true);
                this.insertDirectChatLine(to, user, message, timestamp);
            } else {
                this.DirectChat.handleChat(user, message, timestamp);
                this.DirectChat.updateTextInDockedChat(user.u, this.escapeHTML(message), timestamp, false);
                this.insertDirectChatLine(from, user, message, timestamp);
                this.removeComposing(from);
            }
        });

        return true;
    }

    sortByDataTimestamp(a, b) {
        return ($(b).attr('data-timestamp')) < ($(a).attr('data-timestamp')) ? 1 : -1;
    }

    insertDirectChatLine(username, fromUser, message, timestamp) {
        message = this.processMessage(message);
        timestamp = timestamp.toString().substr(0, 10)
        const sig = app.util.hashCode(fromUser.u + timestamp.toString().substr(0, 9) + message.substr(0, 16));
        const root = $(".directChat[data-name='" + username + "']");
        if (root.length && root.find(".directChatLine[data-sig='" + sig + "']").length) {
            return;
        }
        let inserted = false;
        let chatLine;
        chatLine = document.querySelector(this.chatTemplates + " > .directChatLine").cloneNode(true);
        chatLine.querySelector(".chatMessage").innerHTML = message;
        chatLine.setAttribute("data-sig", sig);
        chatLine.setAttribute("data-timestamp", timestamp);
        chatLine.setAttribute("data-username", fromUser.u);
        chatLine.setAttribute("data-is-me", this.Users.isMe(fromUser.u));
        chatLine.setAttribute("title", this.Time.smartTime(this.language, timestamp));
        chatLine.querySelector(".profileImage").style.backgroundImage = "url(\"" + this.Users.getProfileImage(fromUser) + "\")";

        let chatLines = root.find(".directChatLine");
        if (chatLines.length) {
            chatLines.each(function () {
                if (parseInt($(this).attr("data-timestamp")) > parseInt(timestamp)) {
                    $(this).before(chatLine);
                    inserted = true;
                    return false;
                }
            });
        }
        if (!inserted) {
            root.find(".messageList").append(chatLine);
        }

        this.scrollToBottom();
    }

    scrollToBottom(force) {
        if (this.AUTO_SCROLL === true || force === true) {
            const pane = this.getCurrentPane();
            setTimeout(() => {
                if (pane.find(".messageList").length) {
                    pane.find(".viewWrapper").scrollTop(pane.find(".view").height());
                }
            }, 50);
        }
    }

    addPresenceMessage(roomName, message, username) {
        const strokeMessage = jQuery(this.chatTemplates + ' .strokeMessage').clone();
        strokeMessage.on("click", () => {
            this.showUserMenu(username);
        });
        jQuery('.text', strokeMessage).text(message);
        const messages = this.getMessagesObject(roomName);
        messages.append(strokeMessage);
        this.scrollToBottom();
    }

    addCloseEvents(close, parentObj) {
        close.on('click', function () {
            if (this.UserSettings.get('showAnimations') === true) {
                parentObj.fadeOut();
            } else {
                parentObj.hide();
            }
        }.bind(this));

        parentObj.on('mouseenter', function () {
            close.show();
        }).on('mouseleave', function () {
            close.hide();
        });
    }

    addInfoMessage(roomName, message) {
        const chatLine = jQuery(this.chatTemplates + ' .announcement').clone();
        const close = jQuery(this.chatTemplates + ' .closeX').clone();

        if (this.UserSettings.get('showSmileys') === true) {
            message = this.Emoticons.replaceIcons(message);
        }

        this.addCloseEvents(close, chatLine);

        chatLine.addClass('infoMessage');
        chatLine.addClass('bg-back-more');
        chatLine.append(close);
        chatLine.append(message);

        const messages = this.getMessagesObject(roomName);
        messages.append(chatLine);
        this.scrollToBottom();
    }

    addInfoMessageToAll(message) {
        const chatLine = jQuery(this.chatTemplates + ' .announcement').clone();
        const close = jQuery(this.chatTemplates + ' .closeX').clone();
        if (this.UserSettings.get('showSmileys') === true) {
            message = this.Emoticons.replaceIcons(message);
        }
        this.addCloseEvents(close, chatLine);
        chatLine.addClass('infoMessage');
        chatLine.append(close);
        chatLine.append(message);
        jQuery("#visible-panes .messageList").append(chatLine);
        this.scrollToBottom();
    }


    addAnnouncement(msg) {
        // const chatLine = jQuery(this.chatTemplates + ' .announcement').clone();
        // msg = msg.replace('/system ', '');
        // returns {message: , announcementType:} or false
        // this.Announcements.parser(msg, callback);
        // return true;
    }

    insertIntoChat(obj) {
        const chatLine = jQuery(this.chatTemplates + ' .announcement').clone();
        const messages = this.getMessagesObject(this.CURRENT_PUBLIC_ROOM);

        chatLine.html(obj);

        if (this.UserSettings.get('showAnimations') === true) {
            chatLine.hide(0).appendTo(messages).fadeIn(this.ANIMATION_SPEED);
        } else {
            chatLine.appendTo(messages);
        }

        this.scrollToBottom();
    }

    adjustContentLength(roomName) {
        const messages = this.getMessagesObject(roomName);
        const elements = jQuery(messages).children('li').length;
        if (elements >= this.MAX_MESSAGES_SHOWN) {
            jQuery(messages).children('li:first').remove();
        }
    }

    createChat(chatId) {
        if (jQuery('.chat[data-name="' + chatId + '"]', this.chatContainer).length === 0) {
            const chat = jQuery('.chat', this.chatTemplates).clone();
            chat.attr('data-name', chatId);
            chat.attr('name', this.prettifyRoom(chatId));
            jQuery('.rooms', this.chatContainer).before(chat);
        }
    }

    getChat(chatId) {
        return jQuery('.pane[data-name="' + chatId + '"]', this.chatContainer);
    }

    setChatState(chatState, roomName) {
        this.CHAT_STATE = chatState;
        switch (chatState) {
            case this.CHAT_STATES.groupChat:
                const nav = jQuery(".nav", this.chatContainer);
                this.ROOMNAME = roomName;
                jQuery(".settings #close", this.chatContainer).show();
                if (this.config.user.d === false) {
                    jQuery(".iconDirectChat", nav).remove();
                } else {
                    this.DirectChat.loadSavedChatItems();
                    jQuery(".iconDirectChat", nav).fadeIn(this.ANIMATION_SPEED).on("click", () => {
                        this.DirectChat.showDirectChatList();
                    });
                }
                break;

            case this.CHAT_STATES.chat:
                this.DirectChat.showDirectChatList();
                jQuery(".settings #close", this.chatContainer).hide();
                jQuery(".iconDirectChat,.directChat").fadeIn(this.ANIMATION_SPEED);
                jQuery(".nav .iconDirectChat").fadeIn(this.ANIMATION_SPEED).on("click", () => {
                    this.DirectChat.showDirectChatList();
                });
                break;
        }
    }

    setGame(roomName) {
        for (let i in this.config.chat_games) {
            if (roomName.indexOf(this.stripRoomNumber(this.config.chat_games[i].name)) >= 0) {
                this.GAME = this.config.chat_games[i];
                break;
            }
        }
    }

    toggleSettingsMenu(hide) {
        const settingsMenu = document.querySelector(this.chatContainer + " .settingsMenu");
        this.createSettingsMenu();
        if (hide === "hide" || settingsMenu.style.display === "block" || settingsMenu.querySelectorAll("li").length === 0) {
            settingsMenu.style.display = "none";
        } else {
            settingsMenu.style.display = "block";
        }
    }

    createSettingsMenu() {
        const links = [];
        links.push({
            "text": this.language.chatRooms,
            "icon": "fa-home",
            "itemClass": "chatRooms",
            doThis: function (e) {
                e.stopPropagation();
                app.chatWrapper.CegoXMPP.showPane("rooms");
                app.chatWrapper.CegoXMPP.toggleSettingsMenu("hide");
            }
        });
        links.push({
            "text": this.language.directChat,
            "icon": "fa-comment",
            "itemClass": "directChat",
            doThis: function (e) {
                e.stopPropagation();
                app.chatWrapper.CegoXMPP.DirectChat.showDirectChatList();
                //this.toggleSettingsMenu("hide");
            }
        });
        links.push({
            "text": this.language.createGroupChat,
            "icon": "fa-comments",
            "itemClass": "createGroupChat",
            doThis: function (e) {
                e.stopPropagation();
                app.chatWrapper.CegoXMPP.createPrivateRoom();
                app.chatWrapper.CegoXMPP.toggleSettingsMenu("hide");
            }
        });
        links.push({
            "text": this.language.onlineFriends,
            "icon": "fa-user-friends",
            "itemClass": "friendList",
            doThis: function (e) {
                e.stopPropagation();
                app.chatWrapper.CegoXMPP.showPane("friends");
                app.chatWrapper.CegoXMPP.toggleSettingsMenu("hide");
            }
        });
        if (this.CURRENT_ROOM != null) {
            links.push({
                "text": this.language.inviteUsers,
                "icon": "fa-comment-medical",
                "itemClass": "inviteToRoom",
                doThis: function (e) {
                    e.stopPropagation();
                    app.chatWrapper.CegoXMPP.createInvites(this.CURRENT_ROOM);
                    app.chatWrapper.CegoXMPP.toggleSettingsMenu("hide");
                }
            });
            links.push({
                "text": this.language.users,
                "icon": "fa-users",
                "itemClass": "userList",
                doThis: function (e) {
                    e.stopPropagation();
                    app.chatWrapper.CegoXMPP.showPane("users");
                    app.chatWrapper.CegoXMPP.toggleSettingsMenu("hide");
                }
            });
            links.push({
                "text": this.language.summonAdmin,
                "icon": "fa-exclamation-circle",
                "itemClass": "summonAdmin",
                doThis: function (e) {
                    e.stopPropagation();
                    const adminsTmp = this.getOnlineModeratorUsernames();
                    const admins = [];
                    if (adminsTmp.length > 1) {
                        admins[""] = this.language.random;
                    }
                    if (adminsTmp.length == 0) {
                        app.chatWrapper.CegoXMPP.modal(this.language.noAdminsOnline, "alert");
                    } else {
                        jQuery(adminsTmp).each(function () {
                            admins[this] = this;
                        });
                        app.chatWrapper.CegoXMPP.modal(this.language.selectAnAdmin, "options", function (admin) {
                            this.summonAdmin(admin);
                        }.bind(this), admins);
                        app.chatWrapper.CegoXMPP.toggleSettingsMenu("hide");
                    }
                }
            });
        }
        if (!this.Users.isAdminUser(this.config.user.u) && !this.Users.isStaff(this.config.user.u)) {
            links.push({
                "text": this.language.chatWithAdmin,
                "icon": "fa-phone",
                "itemClass": "chatWithAdmin",
                doThis: (e) => {
                    e.stopPropagation();
                    const adminsTmp = this.getOnlineModeratorUsernames();
                    let admins = [];
                    if (adminsTmp.length > 1) {
                        admins[""] = this.language.random;
                    }
                    if (adminsTmp.length === 0) {
                        this.modal(this.language.noAdminsOnline, "alert");
                    } else {
                        jQuery(adminsTmp).each(function () {
                            admins[this] = this;
                        });
                        this.modal(this.language.selectAnAdmin, "options", function (admin) {
                            if (admin.length <= 0) {
                                const onlineAdmins = this.getOnlineModeratorUsernames();
                                admin = onlineAdmins[Math.floor(Math.random() * onlineAdmins.length)]
                            }
                            this.Users.getUserObject(admin, function (user) {
                                this.DirectChat.initiateDirectChat(user);
                            }.bind(this));
                        }.bind(this), admins);
                        this.toggleSettingsMenu("hide");
                    }
                }
            });
        }
        links.push({
            "text": this.language.settings,
            "icon": "fa-cog",
            "itemClass": "settingsItem",
            doThis: function (e) {
                e.stopPropagation();
                app.chatWrapper.CegoXMPP.showPane("settings");
                app.chatWrapper.CegoXMPP.navIconButton("back");
                app.chatWrapper.CegoXMPP.toggleSettingsMenu("hide");
            }
        });
        links.push({
            "text": this.language.help,
            "icon": "fa-info-circle",
            "itemClass": "settingsItem",
            doThis: function (e) {
                e.stopPropagation();
                app.chatWrapper.CegoXMPP.showPane("help");
                app.chatWrapper.CegoXMPP.navIconButton("back");
                app.chatWrapper.CegoXMPP.toggleSettingsMenu("hide");
            }
        });
        const top = document.querySelector(this.chatContainer + " .chatTop");
        if (typeof (top) === "object") {
            const settingsMenu = top.querySelector(".settingsMenu");
            const ul = document.createElement("ul");
            settingsMenu.innerHTML = "";
            settingsMenu.appendChild(ul);
            for (let prop in links) {
                const btn = document.createElement("li");
                let itemClass = "";
                if (typeof links[prop].itemClass === "string") {
                    itemClass = links[prop].itemClass;
                }
                btn.innerHTML = "<div class=\"flagObject " + itemClass + "\"><div class=\"icon fas " + links[prop].icon + "\"></div><div>" + links[prop].text + "</div></div>";
                btn.onclick = links[prop].doThis.bind(this);
                settingsMenu.querySelector('ul').appendChild(btn);
            }
        }
    }

    search(messageObj, e) {
        switch (e.which) {
            case 8:
                e.preventDefault();
                messageObj.value = messageObj.value.substr(0, messageObj.value.length - 1);
                this.resetSearch();
                if (messageObj.value) {
                    this.searchForUsername(messageObj, this.SEARCH_OBJECT);
                } else {
                    return;
                }
                break;
            case 13:
            case 39:
                e.preventDefault();
                this.cycleResults(messageObj, 'forward');
                if (this.SEARCH_OBJECT.hasOwnProperty(messageObj.value) === true) {
                    this.Users.getUserObject(messageObj.value, (user) => {
                        this.DirectChat.initiateDirectChat(user);
                        this.resetSearch();
                    });
                    return;
                }
                break;

            default:
                if (e.key.length === 1) {
                    e.preventDefault();
                    messageObj.value += e.key;
                    this.resetSearch();
                    this.searchForUsername(messageObj, this.SEARCH_OBJECT);
                } else {
                    return;
                }

                break;
        }
        this.getCurrentPane().find("li").css("display", "none");
        if (this.SEARCH.result.length > 0) {
            if (typeof this.SEARCH.result[0].username === "string" && typeof messageObj.value === "string") {
                const searchStr = this.SEARCH.result[0].username.toLowerCase().replace(messageObj.value.toLowerCase(), messageObj.value);
                jQuery(".searchBoxResult", this.chatContainer).val(searchStr);
            } else {
                jQuery(".searchBoxResult", this.chatContainer).val('');
            }
            for (let prop in this.SEARCH.result) {
                this.getCurrentPane().find('li[data-username="' + this.SEARCH.result[prop].username + '"]').css("display", "");
            }
        }
    }

    resetSearch() {
        this.SEARCH = {
            result: [],
            pointer: 0,
            startPos: 0,
        };
        jQuery(".searchBoxResult", this.chatContainer).val('');
        jQuery(".directChatItem,.friendLine").css("display", "");
    }

    toggleSearch(pane) {
        const that = this;
        const search = jQuery('.' + pane + ' .search', this.chatContainer);
        jQuery('.searchBox', search).val('').focus().attr('placeholder', this.language.search + '...');
        jQuery('.searchBoxResult', search).val('');

        setTimeout(function () {
            jQuery('.pane.' + pane + ' li[data-username]').each(function () {
                that.SEARCH_OBJECT[jQuery(this).attr('data-username')] = null;
            });
        }, 1000);
    }

    setAutoScroll(el) {
        if ((el.scrollHeight - el.offsetHeight) - el.scrollTop > 40) {
            this.AUTO_SCROLL = false;

        } else {
            this.AUTO_SCROLL = true;
        }
    }

    bindEvents() {
        const that = this;
        jQuery(".iconBack").on("click", () => {
            if (jQuery("#visible-panes .pane").length > 1) {
                jQuery("#panes").append(this.getCurrentPane());
                this.showPane(this.getCurrentPane());
            }
        });

        jQuery(this.chatContainer + " #close").on("click", function () {
            that.hideChat();
        });

        jQuery(this.chatContainer + " .showIcons").on("click", function () {
            jQuery(".pane.settings .chatIconsContainer").fadeIn(this.ANIMATION_SPEED);
        }.bind(this));

        jQuery(this.chatContainer).on("click", ".chatLine .user", function (e) {
            const chatLine = jQuery(e.target).parents(".chatLine");
            const username = chatLine.attr("data-username");

            that.showUserMenu(username);
        });

        jQuery(this.chatContainer).on("click", ".users .userLine", function () {
            const username = jQuery(this).attr("data-username");

            that.showUserMenu(username);
        });

        const iconMenu = document.querySelector(this.chatContainer + " .iconMenu");
        if (iconMenu) {
            iconMenu.onclick = function () {
                if (this.CHAT_STATE === this.CHAT_STATES.spilnu) {
                    this.showPane("settings");
                } else {
                    this.toggleSettingsMenu();
                }
            }.bind(this);
        }
        const iconNewDC = document.querySelector(this.chatContainer + " .iconNewDC");
        if (iconNewDC) {
            iconNewDC.onclick = function () {
                this.showPane("friends");
            }.bind(this);
        }

        jQuery(this.chatContainer).on("click", ".friends .friendLine .username", function () {
            const username = jQuery(this).parent().attr("data-username");
            that.modal(that.language.startChatWith.replace("XX", that.capitalize(username)), "confirm", function () {
                that.Users.getUserObject(username, function (user) {
                    that.DirectChat.initiateDirectChat(user);
                });
            });
        });

        jQuery(this.chatContainer).on("click", ".friendLine .profileImage", function () {
            let username = jQuery(this).parents(".friendLine").attr("data-username");
            that.showUserMenu(username);
        });

        if (this.CHAT_STATE === this.CHAT_STATES.groupChat) {
            jQuery(this.chatContainer).on('click', '.friends .friendLine .chatMessage', function () {
                const room = jQuery(this).attr('data-room');
                that.modal(that.language.joinThisRoom, 'confirm', function () {
                    that.joinRoom(room);
                });
            });
        }

        /* Update time ago live */
        jQuery(this.chatContainer).on('mouseenter', '.chatLine', function () {
            const timeAgo = jQuery(this).attr('data-timestamp');
            jQuery('.chatMessage', this).attr('title', that.Time.timeAgo(that.language, timeAgo));

        });

        /* Click on room to join */
        jQuery(this.chatContainer).on('click', '.roomLine .room', function () {
            const root = jQuery(this).parent();
            const rootRoom = root.attr('data-room');
            const siblings = root.siblings("[data-parent='" + rootRoom + "']");
            if (root.attr('data-folder') === 'true') {
                if (root.data("isOpen") !== true) {
                    siblings.show(200);
                    root.data("isOpen", true);
                } else {
                    siblings.not(".currentRoom").hide(200);
                    root.data("isOpen", false);
                }
            } else {
                const roomName = root.attr('data-room');
                if (that.CURRENT_ROOM === roomName) {
                    that.showPane("chat[data-name='" + roomName + "']");
                } else {
                    that.joinRoom(roomName);
                }
            }
        });

        jQuery(this.chatContainer).on("click", ".directChatLine .profileImage", function () {
            that.showUserMenu(jQuery(this).parent().attr("data-username"));
        });

        jQuery(this.chatContainer).on('click', '.sendButton', () => {
            this.sendAction(this.inputField.getInput());
        });

        /* Bind ENTER key to submit message */
        jQuery(this.chatContainer).on('keydown', '.chatText', function (e) {
            if (e.which === 13) {
                e.preventDefault();
                this.sendAction(this.inputField.getInput());
                setTimeout(() => {
                    this.SEND_COMPOSING = true;
                }, 1000);
            }
        }.bind(this)).focus();

        jQuery(this.chatContainer).on('keyup', '.chatText', function (e) {
            const toUsername = this.inputField.receiver;
            const messageObj = jQuery(e.target);
            const text = messageObj[0].value;
            if (text.length > this.MAX_CHAT_TEXT_LENGTH) {
                messageObj[0].value = text.substr(0, this.MAX_CHAT_TEXT_LENGTH);
            }
            if (this.inputField.chatType === 'chat' && this.inputField.textInput.val().length) {
                if (this.SEND_COMPOSING === true) {
                    this.SEND_COMPOSING = false;
                    this.sendComposingMessage(toUsername);
                    this.COMPOSE_TIMER = setTimeout(function () {
                        this.SEND_COMPOSING = true;
                    }.bind(this), 10000);
                }
            }
        }.bind(this));
        jQuery(this.chatContainer).on('keyup paste', '.chatBox .chatText', function (e) {
            this.inputField.autoGrow();
        }.bind(this));

        /* TAB searches in userlist */
        jQuery(this.chatContainer).on('keydown', '.chatBox .chatText', function (e) {
            const messageObj = jQuery(e.target);
            if (e.which === 9) { /* TAB */
                e.preventDefault();
                if (messageObj) {
                    if (this.SEARCH.result.length === 0) {
                        this.searchForUsername(messageObj, this.USERS_IN_ROOM);
                    }
                }
                this.cycleResults(messageObj);
            } else {
                this.SEARCH = {
                    result: [],
                    pointer: 0,
                    startPos: 0
                };
            }
        }.bind(this)).focus();

        jQuery(this.chatContainer).on("keydown clear", ".chatBox .searchBox", function (e) {
            this.search(e.target, e);
        }.bind(this)).focus();
        const chatContainer = document.querySelector(this.chatContainer);
        if (chatContainer) {
            chatContainer.onclick = function (e) {
                e.stopPropagation();
            };
        }
    }

    sendAction(messageObj) {
        this.Emoticons.close();
        if (messageObj.html().length >= 1) {
            if (this.connectionManager.isConnected()) {
                window.savedSelection = 0;
                this.sendMessage(app.util.htmlDecode(messageObj.html()));
                this.this.inputField.disable();
                this.scrollToBottom(true);
                messageObj.html("");
            } else {
                this.loading("show");
            }
        } else if (messageObj.val().length >= 1) {
            if (this.connectionManager.isConnected()) {
                this.sendMessage(messageObj.val());
                this.inputField.disable();
                this.inputField.autoGrow();
                this.scrollToBottom(true);
            } else {
                this.loading("show");
            }
        }
    }

    addTextFromLang() {
        this.addTextFromLangGeneric(this.chatContainer);
        this.addTextFromLangGeneric(this.chatTemplates);
    }

    addTextFromLangGeneric(container) {
        const elements = document.querySelectorAll(container + ' [data-lang]');
        let element;
        for (let i = 0; i < elements.length; i++) {
            element = elements[i];
            const field = element.dataset.lang;
            element.innerText = this.language.all[field];
        }
    }

    navIconButton(state) {
        switch (state) {
            case 'close':
                jQuery('.nav .iconBack, .nav .iconMinimize').fadeOut(this.ANIMATION_SPEED, function () {
                    jQuery('.nav .iconClose').fadeIn(this.ANIMATION_SPEED);
                }.bind(this));
                break;
            case "back":
                jQuery(".nav .iconClose, .nav .iconMinimize").fadeOut(this.ANIMATION_SPEED, function () {
                    jQuery(".nav .iconBack").fadeIn(this.ANIMATION_SPEED);
                }.bind(this));
                break;
            case "minimize":
                jQuery(".nav .iconClose, .nav .iconBack").fadeOut(this.ANIMATION_SPEED, function () {
                    jQuery(".nav .iconMinimize").fadeIn(this.ANIMATION_SPEED);
                }.bind(this));
                break;
            case "hide":
                jQuery(".nav .iconClose").stop(true).fadeOut(this.ANIMATION_SPEED);
                jQuery(".nav .iconBack").stop(true).fadeOut(this.ANIMATION_SPEED);
                jQuery(".nav .iconMinimize").stop(true).fadeOut(this.ANIMATION_SPEED);
                break;
        }
    }

    showPane(pane, headline) {
        let paneObj;
        if (typeof pane === "object") {
            paneObj = pane;
            pane = paneObj.attr("class").substr(5);
            if (!headline) {
                if (paneObj.attr("name")) {
                    headline = paneObj.attr("name");
                } else {
                    if (paneObj.attr("id")) {
                        headline = this.prettifyRoom(paneObj.attr("id"));
                    }
                }
            }
        } else {
            paneObj = jQuery(this.chatContainer + " .pane." + pane);
        }
        if (!paneObj.length) {
            return;
        }
        if (pane.indexOf("chat[") === 0) {
            pane = "chat";
        }
        if (pane.indexOf("directChat[") === 0) {
            pane = "directChat";
        }
        switch (pane) {
            case 'chat':
                if (!headline) {
                    if (this.CURRENT_ROOM) {
                        const roomObj = this.getRoomObject(this.CURRENT_ROOM);
                        headline = roomObj.prettyName;
                    } else {
                        headline = 'Chat';
                    }
                }

                this.inputField.setChat();
                this.scrollToBottom(true);
                break;
            case "directChat":
                this.inputField.setDirectChat(headline);
                this.DirectChat.resetUnreadMessages(headline);
                this.navIconButton("back");
                this.scrollToBottom(true);
                break;

            case 'notifications':

                headline = this.language.notifications;

                this.inputField.hide();

                if (this.CHAT_STATE === this.CHAT_STATES.chat) {
                    this.navIconButton('minimize');
                } else {
                    this.navIconButton('back');
                }

                break;
            case 'directChatDock':

                this.DirectChat.VISIBLE_CHAT = undefined;

                this.inputField.hide();

                headline = this.language.directChat;

                if (this.CHAT_STATE === this.CHAT_STATES.chat) {
                    this.navIconButton('hide');
                } else {
                    this.navIconButton('back');
                }

                this.DirectChat.toggleEmptyMessage();

                this.toggleSearch(pane);

                break;
            case 'users':
                this.inputField.hide();
                headline = this.language.users;
                this.navIconButton('back');

                const adminList = jQuery(this.chatContainer + ' .users .adminList');
                const friendList = jQuery(this.chatContainer + ' .users .friendList');
                const userList = jQuery(this.chatContainer + ' .users .userList');

                this.arrangeDesc(adminList);
                this.arrangeDesc(userList);
                this.arrangeDesc(friendList);

                this.toggleUserLists();
                this.updateOnlineUsers('users');

                break;
            case 'rooms':
                this.inputField.hide();
                this.getRoomList();

                headline = this.language.chatRooms;
                this.navIconButton('back');
                break;
            case 'friends':

                this.inputField.hide();
                headline = this.language.onlineFriends;
                this.navIconButton('back');

                this.arrangeFriendItems();
                this.toggleSearch(pane);

                break;
            case 'settings':
                this.inputField.hide();
                headline = this.language.settings;

                break;

            case 'help':
                headline = this.language.help;

                break;

            case 'userProfile':
                this.inputField.hide();

                break;
            default:

                break;
        }

        if (headline) {
            paneObj.data("name", headline);
        }
        if (paneObj !== this.getCurrentPane()) {
            jQuery("#visible-panes").append(paneObj);
        }

        this.toggleSettingsMenu('hide');
        this.checkNavButtons();
    }

    clearPane(name) {
        $(".pane[data-name='" + name + "']").remove();
    }

    adjustTop() {
        const content = jQuery('.viewWrapper', this.chatContainer);
        const top = jQuery('.chatTop', this.chatContainer).outerHeight(true);
        content.css({'top': top + 'px'});
    }

    adjustBottom(callback) {
        // const content = jQuery('.viewWrapper', this.chatContainer);
        // const textareaH = jQuery('.chatText', this.chatContainer).outerHeight(true);
        // const bottom = (this.inputField.isVisible()) ? textareaH : 0;
        // content.css({'bottom': bottom + 'px'});
        // if (typeof (callback) === 'function') {
        //     callback();
        // }
    }

    getCurrentPane() {
        return jQuery("#visible-panes .pane").last();
    }

    isCurrentPane(pane) {
        return this.getCurrentPane().is(jQuery(this.chatContainer + " #visible-panes " + pane + ".pane").first());
    }

    cycleResults(input, direction) {
        if (typeof input.value !== "string") {
            if (typeof input[0].value === "string") {
                input = input[0]
            } else {
                return;
            }
        }
        if (this.SEARCH.result.length > 0) {
            const space = (this.SEARCH.startPos > 0) ? ' ' : '';
            input.value = input.value.substring(0, this.SEARCH.startPos) + space + this.SEARCH.result[this.SEARCH.pointer].username;

            if (direction === undefined || direction === 'forward') {
                this.SEARCH.pointer = (this.SEARCH.pointer < this.SEARCH.result.length - 1) ? this.SEARCH.pointer + 1 : 0;
            } else {
                this.SEARCH.pointer = (this.SEARCH.pointer - 1 >= 0) ? this.SEARCH.pointer - 1 : this.SEARCH.result.length - 1;
            }
        }
    }

    searchForUsername(input, searchObject) {
        if (!searchObject) {
            return;
        }
        if (typeof input.value !== "string") {
            if (typeof input[0].value === "string") {
                input = input[0]
            } else {
                return;
            }
        }

        const value = input.value;

        this.SEARCH.startPos = value.substring(0, this.getCaretPosition(input)).lastIndexOf(' ');
        this.SEARCH.startPos = (this.SEARCH.startPos === -1) ? 0 : this.SEARCH.startPos;
        const searchFor = $.trim(value.substring(this.SEARCH.startPos, this.getCaretPosition(input)));
        if (searchFor.length > 0) {
            let pointer = 0;
            for (let prop in searchObject) {
                if (searchObject.hasOwnProperty(prop)) {
                    const idx = prop.toLowerCase().indexOf(searchFor.toLowerCase());
                    if (idx >= 0) {
                        this.SEARCH.result[pointer] = {
                            username: prop,
                            sort: idx
                        };
                        pointer++;
                    }
                }
            }
            this.SEARCH.result.sort(function (a, b) {
                return a.sort - b.sort;
            });
        }
    }

    muteUser(username, time) {
        app.storage.set("mute:" + username, time);
    }

    capitalize(str) {
        if (str && str.length > 0) {
            return str[0].toUpperCase() + str.substring(1);
        }
        return "";
    }

    getCaretPosition(input) {
        if ('selectionStart' in input) {
            return input.selectionStart;
        }
        return 0;
    }

    hideChat() {
        this.chatWrapper.hideChat();
    }

    spamBlock() {
        if (this.MSG_BLOCKING === true) {
            return true;
        }
        let timeDiff = (this.Time.getTimestamp() - this.SEND_TIME);
        if (timeDiff < 10) {
            if (this.MSG_COUNTER++ >= 3) {
                this.MSG_BLOCKING = true;
                this.addInfoMessageToAll(this.language.sentTooManyMessages);
                setTimeout(function () {
                    this.MSG_BLOCKING = false;
                    this.addInfoMessageToAll(this.language.youCanSendMessagesAgain);
                    this.inputField.enable();
                }.bind(this), 10000);
                return true;
            }
        } else {
            this.MSG_COUNTER = 0;
            this.SEND_TIME = this.Time.getTimestamp();
        }

        return false;
    }

    muteBlock() {
        if (this.Users.isMuted(app.config.user.u)) {
            this.addInfoMessage(this.CURRENT_ROOM, app.config.translate.you_have_been_muted + " (" + app.util.timeTill(app.storage.get("mute:" + app.config.user.u)) + ")");
            return true;
        }

        return false
    }

    sendMessage(text) {
        if (this.config.user.te) {
            this.addInfoMessageToAll(this.language.instantUserMessage);
            return;
        }
        if (this.muteBlock() || this.spamBlock()) {
            return;
        }
        let msg = this.escapeHTML($.trim(text));
        if (!msg) {
            return;
        }
        let receiver;
        let chatType = this.inputField.chatType;
        let toUsername = false;

        if (chatType === "chat") {
            toUsername = this.inputField.receiver;
        }


        /* Admin actions */
        if (this.Users.isAdminUser(this.config.user.u) || this.Users.isStaff(this.config.user.u)) {
            const match = msg.match(/\/(ban|unban|kick|mute) (\S+)/);
            if (match !== null) {
                const action = match[1];
                const username = match[2];
                this.adminAction(username, action, action);
                return;
            }
        } else {
            if (msg.indexOf("/admin ") === 0) {
                msg = msg.substring(6);
            } else if (msg.indexOf("/me ") === 0) {
                msg = msg.substring(3);
            }
        }
        if (msg.search('#F') >= 0) {
            let friends = "";
            for (let friend in this.FRIENDS_IN_ROOM) {
                friends += friend + ", ";
            }
            if (friends) {
                msg = msg.replace("#F", friends.substring(0, friends.length - 2));
            } else {
                msg = msg.replace("#F", "");
            }
        }

        if (chatType === 'groupchat') {
            receiver = this.getRoomJID(this.CURRENT_ROOM);
        } else {
            if (chatType === 'chat') {
                if (this.DirectChat.makeChatPersistent) {
                    app.ajax.post("/services/chat/direct/create", {name: toUsername}, () => {
                        this.DirectChat.makeChatPersistent = false;
                    });
                }
                receiver = this.getBareJID(toUsername);
                this.sendEventToAllClients({event: "directMessageSend", mess: msg, username: toUsername});
            }
        }

        const message = $msg({
            type: chatType,
            to: receiver
        }).c('x', {
            xmlns: 'chat:msg',
            timestamp: this.Time.getTimestamp()
        }).up().c('body').t(msg).tree();
        this.connectionManager.send(message);
    }

    sendEventToAllClients(obj) {
        const msgAttrs = {
            to: this.getBareJID(this.config.user.u)
        };
        const xAttrs = {
            xmlns: 'chat:event',
            timestamp: this.Time.getTimestamp()
        };

        $.extend(true, xAttrs, obj);
        const message = $msg(msgAttrs).c('x', xAttrs).tree();
        this.connectionManager.send(message);
    }

    sendEventTo(username, obj) {
        const msgAttrs = {
            to: this.getBareJID(username)
        };
        const xAttrs = {
            xmlns: 'chat:event',
            timestamp: this.Time.getTimestamp()
        };

        $.extend(true, xAttrs, obj);

        const message = $msg(msgAttrs).c('x', xAttrs).tree();
        this.connectionManager.send(message);
    }

    sendComposingMessage(to) {
        //http://jabber.org/protocol/chatstates
        const message = $msg({
            to: this.getBareJID(to),
            type: "chat"
        }).c("composing", {
            xmlns: "chatstates"
        }).tree();
        this.connectionManager.send(message);
    }

    sendPauseMessage(to) {
        const message = $msg({
            to: this.getBareJID(to),
            type: "chat"
        }).c("pause", {
            xmlns: "chatstates"
        }).tree();
        this.connectionManager.send(message);
    }

    stripRoomNumber(roomName) {
        const index = roomName.lastIndexOf('_');
        if (index > 0) {
            return roomName.substr(0, index);
        }

        return roomName;
    }

    addRoomNumber(roomName) {
        if (typeof roomName !== "undefined" && roomName.indexOf("_") < 0) {
            roomName += '_1';
        }

        return roomName;
    }

    getRoomNumber(roomName) {
        const result = roomName.match(/.*(?=_([0-9]*))/);
        if (result !== null) {
            return parseInt(result[1], 10);
        } else {
            return 0;
        }
    }

    handleInvites(msg) {
        const roomJID = jQuery('x', msg).attr('jid');
        const from = jQuery(msg).attr('from');
        const node = Strophe.getNodeFromJid(roomJID);
        if (node === this.CURRENT_ROOM) {
            return true;
        }
        const autoJoin = jQuery('x', msg).attr('autoJoin');
        if (autoJoin === 'no') {
            jQuery("#instantMessages").addClass("show").find(".dropdown-menu").addClass("show");
            let reason = jQuery('x', msg).attr('reason');
            reason = (typeof (reason) !== 'undefined') ? reason : this.language.invitesYouToThisChatRoom + ' "' + ((this.isPrivateRoom(node)) ? this.prettifyPrivateRoom(node, "-" + this.getPrivateRoomOwner(node)) : node) + '"';
            let txt = this.capitalize(Strophe.getNodeFromJid(from)) + ': ' + reason;
            this.modal(txt, 'confirm', function () {
                this.joinRoom(node);
            }.bind(this));

            return true;
        }

        this.joinRoom(node);

        return true;
    }

    handleJoinedRoom(roomName) {
        clearTimeout(this.ROOM_CREATE_TIMER);
        this.ROOM_CREATE_TRIES = 0;
        this.JOINING_ROOM = null;
        this.JOINED_ROOMS[roomName] = true;
        this.CURRENT_ROOM = roomName;

        let headline = "";

        if (this.hasRoomObject(roomName)) {
            const room = this.getRoomObject(roomName);
            headline = room.prettyName;
            if (!room.private) {
                this.CURRENT_PUBLIC_ROOM = roomName;
            }
        } else {
            if (this.isPrivateRoom(roomName)) {
                headline = this.prettifyPrivateRoom(roomName)
            } else {
                headline = this.prettifyRoom(roomName);
                this.CURRENT_PUBLIC_ROOM = roomName;
            }
        }
        this.showPane("chat[data-name='" + roomName + "']", headline);
        this.loading('hide');
        this.AUTO_SCROLL = true;
        this.scrollToBottom();
        setTimeout(() => {
            if (this.config.user.te) {
                this.addInfoMessageToAll(this.language.instantUserMessage);
            } else {
                this.showFriendsInRoomMessage(roomName);
            }
        }, 250);
    }

    handleReconnectedRoom(roomName) {
        clearTimeout(this.ROOM_CREATE_TIMER);
        this.ROOM_CREATE_TRIES = 0;
        this.JOINING_ROOM = null;
        this.JOINED_ROOMS[roomName] = true;
        this.CURRENT_ROOM = roomName;
        this.loading('hide');
    }

    subscribeToGameEvents(game) {
        const p = $pres({
            to: "gameevents@services.cego.dk/" + game
        }).tree();
        this.connectionManager.send(p);
    }

    saveData(key, value) {
        app.storage.set(this.config.user.id + ":" + key, JSON.stringify(value));
    }

    loadData(key) {
        const data = app.storage.get(this.config.user.id + ":" + key);
        if (typeof data === "string") {
            return JSON.parse(data);
        } else {
            return null;
        }
    }

    showUserMenu(username) {
        if (this.Users.isMe(username)) {
            return;
        }
        this.Users.getUserObject(username, (user) => {
            const userMenu = jQuery(this.chatContainer + ' .userMenu');
            const overlay = jQuery(this.chatContainer + ' .overlayMsg');
            jQuery('*', userMenu).off();
            userMenu.off();
            overlay.off();
            jQuery('.profileImage', userMenu).css('background-image', 'url("' + this.Users.getProfileImage(user) + '")');
            const usernameLink = userMenu.find(".username");
            usernameLink.addClass(user.k);
            usernameLink.html(user.u + ((this.Users.isAdminUser(user.u) || this.Users.isStaff(user.u)) ? " (admin)" : ""));
            usernameLink.on('click', function () {
                this.showUserProfile(username);
                this.hideUserMenu();
            }.bind(this));

            if (!user.d || !this.config.user.d) {
                jQuery('.instantMessage', userMenu).hide();
            } else {
                jQuery('.instantMessage', userMenu).on('click', () => {
                    this.DirectChat.initiateDirectChat(user);
                    this.hideUserMenu();
                });
            }
            if (!user.f || !this.config.user.f || this.isFriend(username)) {
                jQuery('.makeFriend', userMenu).hide();
            } else {
                jQuery('.makeFriend', userMenu).on('click', function () {
                    this.friendRequest(username);
                    this.hideUserMenu();
                }.bind(this));
            }

            jQuery(".showMiniProfile", userMenu).on("click", function () {
                this.showUserProfile(username);
                this.hideUserMenu();
            }.bind(this));

            jQuery('.giveVip', userMenu).on('click', function () {
                app.ajax.modal('/services/shop/give-vip/' + user.id)
            }.bind(this));

            if (this.Users.isAdminUser(username)) {
                jQuery(".unIgnoreUser", userMenu).hide();
                jQuery(".ignoreUser", userMenu).hide();
                jQuery(".blockUser", userMenu).hide();
            } else {
                if (this.Users.isIgnoredUser(username) === false) {
                    jQuery('.unIgnoreUser', userMenu).hide();
                } else {
                    jQuery('.ignoreUser', userMenu).hide();
                }
                jQuery(".ignoreUser", userMenu).on("click", () => {
                    this.ignoredUsers[username] = true;
                    this.hideUserMenu();
                });
                jQuery(".unIgnoreUser", userMenu).on("click", () => {
                    this.ignoredUsers[username] = false;
                    this.hideUserMenu();
                });
                jQuery(".blockUser", userMenu).on("click", () => {
                    app.ajax.post(this.SETTINGS.ajaxScript.blockUser, {"username": user.u},
                        () => {
                            this.sendEventToAllClients({"event": "blocked", "username": user.u});
                            this.sendEventTo(user.u, {
                                "event": "blocked",
                                "username": this.config.user.u
                            });
                            this.hideUserMenu();
                        });
                    jQuery(".blockUser", userMenu).hide();
                    jQuery(".ignoreUser", userMenu).hide();
                    jQuery(".unIgnoreUser", userMenu).hide();
                });
                jQuery(".report", userMenu).on("click", () => {
                    app.reportContent.report({dataset: {type: "profile", content_id: user.id}});
                    this.hideUserMenu();
                });
            }

            if ((this.Users.isAdminUser(this.config.user.u) && !this.Users.isAdminUser(username)) || (this.Users.isStaff(this.config.user.u) && !this.Users.isStaff(username))) {
                jQuery('.mute', userMenu).show().on('click', function () {
                    this.adminAction(username, 'mute', 'mute');
                    this.hideUserMenu();
                }.bind(this));
                jQuery('.kick', userMenu).hide();
                jQuery('.ban', userMenu).show().on('click', function () {
                    this.adminAction(username, 'ban', 'ban');
                    this.hideUserMenu();
                }.bind(this));
                jQuery('.blockUser', userMenu).hide();
                jQuery('.ignoreUser', userMenu).hide();
            } else {
                jQuery('.mute', userMenu).hide();
                jQuery('.kick', userMenu).hide();
                jQuery('.ban', userMenu).hide();
            }

            userMenu.stop().fadeIn(this.ANIMATION_SPEED);
            overlay.stop().fadeIn(this.ANIMATION_SPEED).on("click", () => {
                this.hideUserMenu();
            });
        });
    }

    hideUserMenu() {
        jQuery(this.chatContainer + ' .userMenu, .overlayMsg').stop().fadeOut(this.ANIMATION_SPEED, () => {
            jQuery(".userMenu ul *").removeAttr("style");
        });
    }

    handleAnnouncement(msg) {
        // const body = jQuery("body", msg)[0];
        // const html = jQuery("html", msg)[0];
        // const txt = (html === undefined) ? body : jQuery("body", msg)[1];
        // if (jQuery("delay", msg).length === 0) {
        //     const announcement = $.trim(jQuery(txt).html());
        //     this.addAnnouncement(announcement);
        // }
        return true;
    }

    handleError(msg) {
        const error = jQuery('error', msg);
        if (error.length) {
            if (error.attr("code") !== "503") {
                this.log(msg.textContent);
            }
        }
        return true;
    }

    handleComposing(msg) {
        const sender = Strophe.getNodeFromJid(jQuery(msg).attr("from"));
        if (this.Users.isIgnoredUser(sender)) {
            return true;
        }
        const chat = this.DirectChat.getChat(sender);

        if (chat.length > 0) {
            this.showComposing(sender);
            if (typeof this.composingTimeout[sender] === "number") {
                clearTimeout(this.composingTimeout[sender]);
            }

            this.composingTimeout[sender] = setTimeout(() => {
                this.removeComposing(sender);
            }, 11000);
        }

        return true;
    }

    showComposing(sender) {
        const composing = jQuery(".directChat[data-name='" + sender + "'] .composing");
        if (composing.length) {
            composing.addClass("active");
        }
    }

    removeComposing(sender) {
        const composing = jQuery(".directChat[data-name='" + sender + "'] .composing");
        if (composing.length) {
            composing.removeClass("active");
        }
    }

    handleGameEvents(msg) {
        const body = jQuery('body', msg);
        const x = jQuery('x', msg);
        const ns = x.attr('xmlns');
        const txt = body.text();
        let result;
        let username;
        let text;

        const nameSpaces = {
            MESSAGE_TYPE_BANK: "cego:xmpp:notification:bank",
            MESSAGE_TYPE_SUPERJACKPOT: "cego:xmpp:notification:superjackpot",
            MESSAGE_TYPE_EXTRAJACKPOT: "cego:xmpp:notification:extrajackpot",
            MESSAGE_TYPE_MEDAL: "cego:xmpp:notification:medal",
            MESSAGE_TYPE_ACHIEVEMENT: "cego:xmpp:notification:achievement",
            MESSAGE_TYPE_RANK: "cego:xmpp:notification:rank",
            MESSAGE_TYPE_GLOBAL: "cego:xmpp:notification:global",
            MESSAGE_TYPE_GAME: "cego:xmpp:notification:game",
            MESSAGE_TYPE_SYSTEM: "cego:xmpp:notification:system",
            MESSAGE_TYPE_SPILNU: "cego:xmpp:notification:spilnu",
            MESSAGE_TYPE_JAVASCRIPT: "cego:xmpp:notification:javascript"
        };

        switch (ns) {
            case nameSpaces.MESSAGE_TYPE_SYSTEM:
                if (txt.match(/<.*>/)) {
                    const html = jQuery('<div>').html(txt);
                    this.insertIntoChat(html);
                } else {
                    this.insertIntoChat(txt);
                }
                break;

            case nameSpaces.MESSAGE_TYPE_BANK:
                /* Split by underscore */
                result = txt.split('_');
                if (result === null) {
                    break;
                }
                username = result[1].split(' ')[0];
                const res = {
                    'username': username,
                    'message': result[1],
                    'bankId': result[2],
                    'last4': result[3]
                };
                res.message = res.message.replace(res.username + ' ', '');
                const bankValue = res.message.match(/\d+/);
                const userTicketId = res.bankId + '_' + res.last4 + '_' + this.config.user.id;
                if (bankValue === null) {
                    break;
                }
                text = this.language.getSharedPrize.replace('5%', Math.floor(bankValue[0] * 0.05));
                this.Users.getUserObject(res.username, function (user) {
                    const o = {
                        'img': this.Users.getProfileImage(user),
                        'title': user.u,
                        'text': res.message,
                        'link': text
                    };
                    const html = this.Announcements.standardAnnouncement(o);
                    jQuery('.image', html).addClass('round');
                    jQuery('.link', html).addClass('prizeShareButton').attr('id', userTicketId).attr('data-username', user.u);

                    this.insertIntoChat(html);
                }.bind(this));

                break;
            case nameSpaces.MESSAGE_TYPE_RANK:
                if (this.UserSettings.get('showRankMessages') === true) {
                    const result = txt.match(/(\S*) (.*)/);
                    if (result === null) {
                        break;
                    }
                    const res = {
                        'username': result[1],
                        'message': result[2]
                    };
                    this.Users.getUserObject(res.username, function (user) {
                        const o = {
                            'img': this.Users.getProfileImage(user),
                            'title': user.u,
                            'text': res.message,
                            'link': this.language.congratulate
                        };
                        const html = this.Announcements.standardAnnouncement(o);
                        jQuery('.link', html).on('click', function () {
                            this.inputField.setText(this.language.congratulations + ' ' + this.capitalize(res.username));
                        }.bind(this)).hide();
                        jQuery('.image', html).addClass('round');

                        this.insertIntoChat(html);
                    }.bind(this));
                }
                break;
        }
        this.adjustContentLength(this.CURRENT_ROOM);

        return true;
    }

    handleEvent(msg) {
        const x = msg.firstChild;
        if (x && typeof x.getAttribute === "function") {
            const event = x.getAttribute("event");
            switch (event) {
                case "unread":
                    this.DirectChat.resetUnreadMessages(x.getAttribute("username"));
                    break;

                case "blocked":
                    const username = x.getAttribute("username");
                    this.DirectChat.removeChat(username);
                    this.Users.removeBlocked(username);
                    app.config.user.b[app.config.user.b.length] = username;
                    break;

                case "delete_room":
                    const name = x.getAttribute("name");
                    this.DirectChat.removeChat(name);
                    $(".roomLine[data-name='" + name + "']").remove();
                    break;

                case "directMessageSend":
                    this.addDirectChatMessage(this.config.user.u, x.getAttribute("username"), x.getAttribute("mess"), x.getAttribute("timestamp"));
                    this.inputField.clear();
                    break;
            }
        }
        return true;
    }

    createMessageObject(xml) {
        xml = $(xml);
        let object = {};
        object.to = Strophe.getNodeFromJid(xml.attr("to"));
        object.type = xml.attr("type");
        switch (object.type) {
            case "chat":
                object.from = Strophe.getNodeFromJid(xml.attr("from"));
                object.resource = Strophe.getResourceFromJid(xml.attr("from"));
                break;

            case"groupchat":
                object.from = Strophe.getResourceFromJid(xml.attr("from"));
                object.resource = Strophe.getNodeFromJid(xml.attr("from"));
                break;
        }
        object.timestamp = xml.find("archived").eq(0).attr("id");
        object.text = xml.find("body").text();
        object.error = xml.find("error");
        object.hasError = (object.error.length > 0 || object.from === undefined);
        object.delayed = xml.find("delay").length > 0;
        object.user = this.Users._getFromCache(object.from);

        return object;
    }

    handleMessage(msg) {
        const msgObject = this.createMessageObject(msg);
        if (msgObject.hasError) {
            return true;
        }
        if (msgObject.text) {
            if (this.Users.isMe(msgObject.from)) {
                this.inputField.clear();
            } else {
                if (this.Users.isBlocked(msgObject.from) || this.Users.isBanned(msgObject.from) || this.Users.isMuted(msgObject.from) || this.Users.isIgnoredUser(msgObject.from)) {
                    this.Users.removeBlocked(msgObject.from);
                    return true;
                }
            }
            switch (msgObject.type) {
                case "chat":
                    this.adjustContentLength(msgObject.from);
                    this.addDirectChatMessage(msgObject.from, msgObject.to, msgObject.text, msgObject.timestamp);
                    break;

                case "groupchat":
                    this.adjustContentLength(msgObject.resource);
                    this.addGroupChatMessage(msgObject);
                    break;
            }
        }

        return true;
    }

    getText(body) {
        return jQuery(body).text();
    }

    handlePresenceError(error, room) {
        switch (error.getAttribute("code")) {
            case "403":
                if (this.ROOM_CREATE_TRIES === 0) {
                    this.createRoom(room);
                } else {
                    this.ROOM_CREATE_TIMER = setTimeout(function () {
                        this.createRoom(room);
                    }.bind(this), 5000);
                }

                this.ROOM_CREATE_TRIES++;
                break;

            case "503":
                this.addInfoMessage(room, this.language.roomIsFull);
                this.joinNextAvailableRoom(room);
                break;
        }
    }

    handlePresence(presence) {
        let from = null;
        let type = null;
        let room = null;
        let user = null;
        let username = null;
        if (typeof presence.getAttributeNames === "function") {
            presence.getAttributeNames().forEach((attr) => {
                switch (attr) {
                    case "from":
                        from = presence.getAttribute(attr);
                        break;

                    case "type":
                        type = presence.getAttribute(attr);
                        break;
                }
            });
        } else {
            return true;
        }

        if (from.indexOf("conference") > 0) {
            room = from.substr(0, from.indexOf("@"));
            username = from.substr(from.lastIndexOf("/") + 1);
        } else {
            username = from.substr(0, from.indexOf("@"));
        }
        if (typeof presence.childNodes === "object" && presence.childNodes.length) {
            presence.childNodes.forEach((node) => {
                switch (node.tagName) {
                    case "user":
                        if (node.textContent.indexOf("%") >= 0) {
                            return true;
                        }
                        user = JSON.parse(node.textContent);
                        if (typeof user.u === "undefined") {
                            user = null;
                            return true;
                        }
                        this.Users.updateUserObject(user.u, user);
                        if (user) {
                            username = user.u;
                        }
                        break;
                    case "error":
                        this.handlePresenceError(node, room);
                        return true;
                }
            });
        }
        if (!username || username.indexOf(room) >= 0 || (room && room.indexOf("tournament_") === 0)) {
            return true;
        }
        if (!this.Users.isMe(username)) {
            if (this.Users.isBlocked(username)) {
                this.Users.removeBlocked(username);
                return true;
            }
        }
        switch (type) {
            case "unavailable":
                if (username) {
                    if (!this.Users.isMe(username)) {
                        if (this.isInRoom(room)) {
                            this.removeUser(username, room);
                        }
                        if (this.isFriend(username)) {
                            this.updateFriendListItemStatus(username, "offline");
                        }
                    }
                }
                break;

            default:
                if (this.isFriend(username)) {
                    this.updateFriendListItemStatus(username, "online");
                }
                if (!room) {
                    break;
                }
                if (this.Users.isMe(username)) {
                    if (!this.isInRoom(room)) {
                        this.handleJoinedRoom(room);
                    } else {
                        this.handleReconnectedRoom(room);
                    }
                } else {
                    if (this.isInRoom(room) || this.joiningRoom(room)) {
                        this.addUser(username, room);
                    }
                }
                break;
        }

        return true;
    }

    isInRoom(room = null) {
        return !!(this.CURRENT_ROOM && this.CURRENT_ROOM === room);
    }

    joiningRoom(room = null) {
        return this.JOINING_ROOM && this.JOINING_ROOM === room;
    }

    handleRoomPresenceJoin(roomName, username) {
        if (this.USERS_IN_ROOM[username] !== 1 || this.connectionManager.reconnected) {
            return;
        }
        if (this.UserSettings.get("presenceAll") === true || this.isPrivateRoom(roomName)) {
            this.addPresenceMessage(roomName, this.capitalize(username) + " " + this.language.joinedTheRoom, username);
        } else if (this.UserSettings.get('presenceFriends') === true) {
            if (this.isFriend(username)) {
                this.addPresenceMessage(roomName, this.capitalize(username) + " " + this.language.joinedTheRoom, username);
            }
        }
    }

    handleRoomPresenceLeave(roomName, username) {
        if (this.UserSettings.get("presenceAll") === true || this.isPrivateRoom(roomName)) {
            this.addPresenceMessage(roomName, this.capitalize(username) + " " + this.language.leftTheRoom, username);
        } else if (this.UserSettings.get('presenceFriends') === true) {
            if (this.isFriend(username)) {
                this.addPresenceMessage(roomName, this.capitalize(username) + " " + this.language.leftTheRoom, username);
            }
        }
    }

    showUserMute(username, expires) {
        if (this.isUserInRoom(username)) {
            this.addInfoMessage(this.CURRENT_ROOM, '<b>' + username + '</b><br>' + app.config.translate.has_been_muted + ' (' + app.util.timeTill(expires) + ')');
        }
    }

    showUserBan(username) {
        if (this.isUserInRoom(username)) {
            this.addInfoMessage(this.CURRENT_ROOM, username + ' ' + app.config.translate.has_been_banned);
        }
    }

    isFriend(username) {
        if (app.config.friends.length) {
            if (app.config.friends.indexOf(username) >= 0) {
                return true;
            }
        }

        return false;
    }

    isUserInRoom(username) {
        return this.USERS_IN_ROOM[username] > 0;
    }

    isTempUser(username) {
        if (username.indexOf("u") === 0 && username.length === 9) {
            return true;
        }
        return false;
    }

    addUser(username, room) {
        if (!this.isTempUser(username)) {
            if (typeof this.USERS_IN_ROOM[username] === "undefined") {
                this.USERS_IN_ROOM[username] = 0;
            }
            this.USERS_IN_ROOM[username] += 1;
            if (this.isFriend(username)) {
                if (typeof this.FRIENDS_IN_ROOM[username] === "undefined") {
                    this.FRIENDS_IN_ROOM[username] = 0;
                }
                this.FRIENDS_IN_ROOM[username] += 1;
            }
            if (this.USERS_IN_ROOM[username] === 1) {
                this.addUserToList(username);
                if (this.isInRoom(room)) {
                    this.handleRoomPresenceJoin(room, username);
                }
            }
        }
    }

    removeUser(username, room) {
        if (this.USERS_IN_ROOM[username] > 0) {
            this.USERS_IN_ROOM[username] -= 1;
            if (this.isFriend(username)) {
                this.FRIENDS_IN_ROOM[username] -= 1;
            }
            if (this.USERS_IN_ROOM[username] === 0) {
                this.removeUserFromList(username);
                this.handleRoomPresenceLeave(room, username);
            }
        }
    }

    addUserToList(username) {
        let list;
        if (this.Users.isAdminUser(username)) {
            list = jQuery(this.chatContainer + " .users .adminList");
        } else if (this.Users.isStaff(username)) {
            list = jQuery(this.chatContainer + " .users .adminList");
        } else if (this.isFriend(username)) {
            list = jQuery(this.chatContainer + " .users .friendList");
        } else {
            list = jQuery(this.chatContainer + " .users .userList");
        }
        if (list.find("[data-username='" + username + "']").length > 0) {
            return false;
        } else {
            this.Users.getUserObject(username, (user) => {
                const userLine = jQuery(this.chatTemplates + " .userLine").clone();
                jQuery('.username', userLine).text(username);
                if (this.Users.isAdminUser(username)) {
                    jQuery(".username", userLine).addClass("admin");
                } else {
                    jQuery(".username", userLine).addClass(user.k);
                }

                userLine.attr('data-username', username);
                userLine.attr('data-userid', user.id);
                list.append(userLine);

                if (this.isCurrentPane('.users')) {
                    this.updateOnlineUsers('users');
                    this.toggleUserLists();
                    this.arrangeDesc(list);
                }
            });
        }
    }

    removeUserFromList(username) {
        jQuery(this.chatContainer + ' .users .userLine[data-username="' + username + '"]').remove();
        this.updateOnlineUsers('users');
    }

    emptyUserlist() {
        jQuery(this.chatContainer + ' .users .userLine').remove();
        this.USERS_IN_ROOM = [];
        this.FRIENDS_IN_ROOM = [];
    }

    createFriendListItem(username) {
        const friendList = jQuery(this.chatContainer + " .friends .friendList");
        let userLine = friendList.find("[data-username='" + username + "']");
        if (userLine.length > 0) {
            return true;
        }

        userLine = jQuery(this.chatTemplates + " .friendLine").clone();
        friendList.append(userLine);
        jQuery(".username", userLine).text(username);
        jQuery(".status", userLine).show();

        this.Users.getUserObject(username, (user) => {
            jQuery(".profileImage", userLine).css("background-image", "url(\"" + this.Users.getProfileImage(user) + "\")");
            if (this.CHAT_STATE === this.CHAT_STATES.groupChat && user.hasOwnProperty("chatRoom")) {
                const roomObj = this.getRoomObject(user.chatRoom);
                if (roomObj !== undefined) {
                    jQuery(".chatMessage", userLine).text(roomObj.prettyName).attr("data-room", roomObj.name);
                }
            }
            jQuery(".username", userLine).addClass(user.k);
            userLine.attr("data-username", user.u);
            userLine.attr("data-userid", user.id);
            userLine.attr("data-order", "0" + user.u);

            this.arrangeFriendItems();
        });

        return true;
    }

    updateFriendListItemStatus(username, status) {
        const friendList = jQuery(this.chatContainer + " .friends .friendList");
        if (friendList.length) {
            if (status === "offline") {
                const userLine = friendList.find("[data-username='" + username + "']");
                userLine.attr("data-order", "1" + username);
                jQuery(".status", userLine).hide();
            } else {
                if (status === 'online') {
                    const userLine = friendList.find("[data-username='" + username + "']");
                    if (userLine.length === 0) {
                        this.createFriendListItem(username);
                    } else {
                        userLine.attr("data-order", "0" + username);
                        jQuery(".status", userLine).show();
                    }
                }
            }
        }
    }

    arrangeFriendItems() {
        const ul = jQuery(this.chatContainer + ' .friends .friendList');
        if (ul.length > 0) {
            ul.children('li').remove().sort(function (a, b) {
                return a.textContent > b.textContent ? 1 : -1;
            }).appendTo(ul);
        }
    }

    updateOnlineUsers(which) {
        jQuery(this.chatContainer + ':visible .' + which + ' ul').each(function () {
            const num = jQuery(this).find('.userLine').length;
            jQuery(this).prev('.headline').find('.num').html(num);
        });
    }

    toggleUserLists() {
        const adminList = jQuery(this.chatContainer + ' .users .adminList');
        const friendList = jQuery(this.chatContainer + ' .users .friendList');
        const userList = jQuery(this.chatContainer + ' .users .userList');

        /* Only show lists with users in */
        if (jQuery('li', adminList).length > 0) {
            adminList.prev('.headline').show();
            adminList.show();
        } else {
            adminList.prev('.headline').hide();
            adminList.hide();
        }

        if (jQuery('li', friendList).length > 0) {
            friendList.prev('.headline').show();
            friendList.show();
        } else {
            friendList.prev('.headline').hide();
            friendList.hide();
        }

        if (jQuery('li', userList).length > 0) {
            userList.prev('.headline').show();
            userList.show();
        } else {
            userList.prev('.headline').hide();
            userList.hide();
        }
    }

    loading(state) {
        const overlay = document.querySelector(this.chatContainer + " .overlayMsg");
        const container = document.querySelector(this.chatContainer + " .wait");
        if (state === "show") {
            if (container) {
                container.style.display = "block";
            }
        } else {
            if (container) {
                container.style.display = "none";
            }
            if (overlay) {
                overlay.style.display = "none";
            }
        }
    }

    prettifyRoom(roomName) {
        if (typeof roomName === "string") {
            roomName = roomName.replace("hidden_", "");
            roomName = roomName.replace(/-/g, " ");
            if ((roomName.indexOf("_1") + 2) === roomName.length) {
                roomName = roomName.replace("_1", "");
            }
            roomName = roomName.replace("_", " - ");

            return roomName;
        }
        return "?";
    }

    prettifyPrivateRoom(roomName) {
        roomName = roomName.replace("private-", "");
        roomName = roomName.substr(0, roomName.lastIndexOf("-" + this.getPrivateRoomOwner(roomName)));

        return roomName;
    }

    isPrivateRoom(roomName) {
        if (typeof roomName === "string") {
            return roomName.indexOf(this.PREFIX_PRIVATE_ROOM) === 0;
        }
        return false;
    }

    getPrivateRoomOwner(roomName) {
        roomName = roomName.substr(roomName.lastIndexOf("-") + 1);
        roomName = roomName.substr(0, roomName.lastIndexOf("_"))
        return roomName;
    }

    createPrivateRoom() {
        const modal = jQuery('.createPrivateRoomModal', this.chatContainer);
        const overlay = jQuery(this.chatContainer + ' .overlayMsg');
        const input = modal.find('input');
        overlay.fadeIn(this.ANIMATION_SPEED);
        modal.fadeIn(this.ANIMATION_SPEED);
        input.focus();

        /* Bind ENTER key to submit */
        input.off().on('keydown', function (e) {
            if (e.which == 13) {
                e.preventDefault();
                modal.find('.ok').click();
            }
        });

        modal.find('.ok').off().on('click', function () {
            let roomName = input.val();
            if (roomName.length > 0) {
                roomName = this.PREFIX_PRIVATE_ROOM + roomName + '-' + this.config.user.u;
                roomName = roomName.toLowerCase().replace(/[^a-z0-9]/g, '-');
                this.joinRoom(roomName);
                this.createInvites(roomName);
                input.val('');
            } else {
                setTimeout(function () {
                    app.chatWrapper.CegoXMPP.modal(app.chatWrapper.CegoXMPP.language.thereAreErrorsInTheInput, 'alert', function () {
                        app.chatWrapper.CegoXMPP.createPrivateRoom();
                    });
                }, 1000);
            }
            modal.fadeOut(this.ANIMATION_SPEED);
            overlay.fadeOut(this.ANIMATION_SPEED);
        }.bind(this));

        modal.find('.cancel').off().on('click', function () {
            modal.fadeOut(this.ANIMATION_SPEED);
            overlay.fadeOut(this.ANIMATION_SPEED);
        }.bind(this));
    }

    createInvites(roomName) {
        const modal = jQuery('.createInvitesModal', this.chatContainer);
        const overlay = jQuery(this.chatContainer + ' .overlayMsg');
        const input = modal.find('input');
        overlay.fadeIn(this.ANIMATION_SPEED);

        modal.fadeIn(this.ANIMATION_SPEED);
        input.focus();

        /* Bind ENTER key to submit */
        input.off().on('keydown', function (e) {
            if (e.which == 13) {
                e.preventDefault();
                modal.find('.ok').click();
            }
        });

        modal.find('.ok').off().on('click', function () {
            const usernames = input.val();
            if (usernames.length > 0) {

                /* Send invitation to all users */
                const users = usernames.split(' ');
                this.invite(users, roomName);
                input.val('')
            } else {
                setTimeout(function () {
                    app.chatWrapper.CegoXMPP.modal(app.chatWrapper.CegoXMPP.language.thereAreErrorsInTheInput, 'alert', function () {
                        app.chatWrapper.CegoXMPP.createInvites(roomName);
                    });
                }, 1000);
            }

            modal.fadeOut(this.ANIMATION_SPEED);
            overlay.fadeOut(this.ANIMATION_SPEED);
            this.addInfoMessage(this.CURRENT_ROOM, usernames + ' ' + this.language.hasBeenInvited);
        }.bind(this));

        modal.find('.cancel').off().on('click', function () {
            modal.fadeOut(this.ANIMATION_SPEED);
            overlay.fadeOut(this.ANIMATION_SPEED);
        }.bind(this));
    }

    invite(usernames, roomName, reason, autoJoin) {
        roomName = (roomName !== undefined) ? roomName : this.CURRENT_ROOM;

        for (let username in usernames) {
            const message = $msg({
                to: this.getBareJID(usernames[username].trim())
            }).c("x", {
                xmlns: "jabber:x:conference",
                jid: this.getRoomJID(roomName),
                reason: reason,
                autoJoin: (autoJoin === undefined) ? "no" : "yes"
            }).tree();
            this.connectionManager.send(message);
        }
    }

    summonAdmin(name) {
        if (name.length > 0) {
            this.inviteAdmin(name);
            setTimeout(function () {
                this.modal(name + ' ' + this.language.isNowCalled, 'alert');
            }.bind(this), 500);

        } else {
            this.summonRandomAdmin();
        }
    }

    summonRandomAdmin() {
        const onlineAdmins = this.getOnlineModeratorUsernames();
        const randomAdmin = onlineAdmins[Math.floor(Math.random() * onlineAdmins.length)]
        this.inviteAdmin(randomAdmin);
        setTimeout(function () {
            this.modal(this.language.anAdminHasBeenAlerted + ' (' + randomAdmin + ')', 'alert');
        }.bind(this), 500);
    }

    inviteAdmin(name) {
        this.invite([name], this.CURRENT_ROOM, this.language.adminIsNeededIn + ":<br/><br/>" + this.CURRENT_ROOM);
    }

    modal(text, type, callback, data) {
        const modal = jQuery('.generalModal', this.chatContainer);
        const overlay = jQuery(this.chatContainer + ' .overlayMsg');
        const input = modal.find('input').empty();
        const select = modal.find('select').empty();
        const cancel = modal.find('.cancel');
        const ok = modal.find('.ok');
        const header = modal.find('.text');

        /* Hide elements */
        input.hide();
        select.hide();
        cancel.hide();

        /* Show modal and init callback */
        header.html(text);
        overlay.fadeIn(this.ANIMATION_SPEED);
        modal.fadeIn(this.ANIMATION_SPEED);
        ok.off().on('click', function () {
            if (typeof (callback) === 'function') {
                switch (type) {
                    case 'prompt':
                        callback(input.val());
                        break;
                    case 'confirm':
                        callback();
                        break;
                    case 'options':
                        callback(select.val());
                        break;
                }
            }
            modal.fadeOut(this.ANIMATION_SPEED);
            overlay.fadeOut(this.ANIMATION_SPEED);
        }.bind(this));

        /* Type situations */
        switch (type) {
            case 'alert':
                modal.find('.ok').css({'margin': 'auto', 'float': 'none'});
                break;

            case 'confirm':
                cancelModalAction();
                break;

            case 'prompt':
                input.show().focus();
                cancelModalAction();
                break;

            case 'options':
                for (let key in data) {
                    if (data.hasOwnProperty(key)) {
                        select.append('<option value="' + key + '">' + data[key] + '</option>');
                    }
                }
                select.show().focus();
                cancelModalAction();
                break;
        }

        /*Internal functions */
        function cancelModalAction() {
            modal.find('.cancel').show();
            modal.find('.cancel').off().on('click', function () {
                modal.fadeOut(this.ANIMATION_SPEED);
                overlay.fadeOut(this.ANIMATION_SPEED);
            });
        }
    }

    arrangeDesc(ul) {
        ul.children('li').remove().sort(this.sortAlpha).appendTo(ul);
    }

    sortAlpha(a, b) {
        return a.textContent.toLowerCase() > b.textContent.toLowerCase() ? 1 : -1;
    }

    arrangeRoomsDesc(ul) {
        //ul.children("li").remove().sort(this.sortAlphaNum).appendTo(ul);
    }

    sortAlphaNum(a, b) {
        a = jQuery(a).attr("data-room");
        b = jQuery(b).attr("data-room");
        const reA = /[^a-zA-Z]/g;
        const reN = /[^0-9]/g;
        const aA = a.replace(reA, "");
        const bA = b.replace(reA, "");
        if (aA === bA) {
            const aN = parseInt(a.replace(reN, ""), 10);
            const bN = parseInt(b.replace(reN, ""), 10);
            return aN === bN ? 0 : aN > bN ? 1 : -1;
        } else {
            return aA > bA ? 1 : -1;
        }
    }

    roomFinder(roomName) {
        if ((roomName.lastIndexOf("_1") + 2) !== roomName.length || (typeof this.AVAILABLE_ROOMS[roomName] === "object" && this.OPTIONS.maxUsers > this.AVAILABLE_ROOMS[roomName].players)) {
            return roomName;
        }
        const baseRoom = roomName.substr(0, roomName.lastIndexOf("_"));
        let index = 1;
        let newName = "";
        while (true) {
            newName = baseRoom + "_" + index++;
            if (typeof this.AVAILABLE_ROOMS[newName] === "object") {
                if (this.OPTIONS.maxUsers > this.AVAILABLE_ROOMS[newName].players) {
                    return newName;
                }
            } else {
                return newName;
            }
        }
    }

    showUserProfile(username) {
        if (this.MODE === this.MODES.page) {
            app.ajax.inject(this.SETTINGS.ajaxScript.userProfile + '/' + username, '#page')
        } else {
            window.open(this.SETTINGS.ajaxScript.userProfile + '/' + username);
        }
    }

    setupDeleteButtons() {
        $("#visible-panes").on("click", "[data-delete] .delete", function () {
            const parent = $(this).parents("[data-delete]");
            const name = parent.attr("data-delete");
            app.ajax.deleteConfirm("/services/chat/delete", {name: name}, () => {
                parent.slideUp(150, function () {
                    $(this).remove();
                });
                app.chatWrapper.CegoXMPP.sendEventToAllClients({event: "delete_room", name: name});
            });
        });
    }

    createRoomList() {
        const roomList = jQuery(this.chatContainer + ' .roomList');
        const privateRoomList = jQuery(this.chatContainer + ' .privateRoomList');
        privateRoomList.html("");
        roomList.html("");
        const folders = {};
        for (let roomName in this.AVAILABLE_ROOMS) {
            const room = this.AVAILABLE_ROOMS[roomName];
            if (room.roomActive === false && room.beta === '0') {
                continue;
            }
            if (roomList.find("[data-room='" + room.name + "']").length > 0) {
                jQuery(this.chatContainer + " [data-room='" + room.name + "'] .onlineUsers").html(room.players > 0 ? room.players : "");
                continue;
            }
            const parent = this.stripRoomNumber(room.name);
            const sibling = roomList.find("[data-parent='" + parent + "']");
            if (folders[parent] === undefined && sibling.length > 0) {
                folders[parent] = $.extend(true, {}, this.getRoomObject(sibling.attr('data-room')));
                folders[parent].name = parent;
                folders[parent].folder = true;
            }

            if (room.icon === false && sibling.length === 0 && room.forceShow === false) {
                continue;
            }
            if (room['private'] === true) {
                privateRoomList.append(this.createRoomItem(room, true));
            } else {
                let roomItem = this.createRoomItem(room);
                if (roomItem) {
                    let parentItem = $(".roomLine[data-parent='" + parent + "']");
                    if (parentItem.length > 0) {
                        parentItem.last().after(roomItem);
                    } else {
                        roomList.append(roomItem);
                    }
                }
            }
        }

        if (privateRoomList.children().length > 0) {
            privateRoomList.show();
            this.arrangeRoomsDesc(privateRoomList);
        } else {
            privateRoomList.hide();
        }
        this.arrangeRoomsDesc(roomList);
        for (let prop in folders) {
            const parentRoom = folders[prop];
            const parentFolder = this.createRoomItem(parentRoom);

            let totalOnline = 0;
            let firstRoom = false;
            const that = this;
            roomList.find("[data-parent='" + prop + "']").each(function () {
                jQuery(this).hide();
                jQuery('.roomName', this).html(that.language.room + ' ' + that.getRoomNumber(jQuery(this).attr('data-room')));
                const players = parseInt(jQuery(this).attr('data-users'), 10);
                totalOnline += (isNaN(players)) ? 0 : players;

                if (firstRoom === false) {
                    firstRoom = jQuery(this);
                    firstRoom.before(parentFolder);
                } else {

                }
            });
            jQuery('.onlineUsers', parentFolder).text(totalOnline);
            jQuery('li', roomList).removeClass('currentRoom');
            const selRoom = roomList.find("[data-room='" + this.CURRENT_ROOM + "']");
            selRoom.addClass('currentRoom');
            const selRoomParent = selRoom.attr('data-parent');
            roomList.find("[data-room='" + selRoomParent + "']").slideDown(100);
            roomList.find(".roomLine.currentRoom").slideDown(100);
        }
    }

    getGameRank(user) {
        if (this.GAME && typeof user.g[this.GAME.gid] !== "undefined") {
            return user.g[this.GAME.gid];
        }

        return 0;
    }

    createRoomItem(room, isPriavte = false) {
        if (typeof room.name !== "string" || room.name === "undefined") {
            return null;
        }
        const roomLine = jQuery(this.chatTemplates + " .roomLine").clone();

        jQuery(".roomName", roomLine).html(room.prettyName ? room.prettyName : this.prettifyRoom(room.name));
        jQuery(".onlineUsers", roomLine).text(room.players > 0 ? room.players : "");
        const image = this.getRoomImage(room);
        if (image) {
            roomLine.find(".room").prepend(image);
        }
        roomLine.attr("data-name", room.name);
        roomLine.attr("data-room", room.name);
        roomLine.attr("data-title", room.prettyName);
        roomLine.attr("data-users", room.players);
        roomLine.attr("data-parent", this.stripRoomNumber(room.name));
        roomLine.attr("data-folder", room.folder);
        if (isPriavte) {
            roomLine.attr("data-delete", room.name);
            roomLine.append($("<div class='delete'>X</div>"));
        }
        return roomLine;
    }

    getRoomImage(room) {
        if (typeof room.image === "string") {
            if (room.image.length > 20) {
                return room.image;
            } else {
                return "<img class='smallImage' src='/services/media/images/" + room.image + "/game-logo-tiny/logo.png'>"
            }
        }
        return "";
    }

    getRoomJID(str) {
        return str + '@' + this.SETTINGS.roomBase + '.' + this.config.domain;
    }

    addSessionRoom(roomObject, save) {
        let addRoom = true;
        const rooms = this.SAVED_SESSION_ROOMS.concat(this.SESSION_ROOMS);
        for (let i in rooms) {
            if (rooms[i].name.toString() === roomObject.name.toString()) {
                addRoom = false;
            }
        }

        if (addRoom) {
            this.SESSION_ROOMS.push(roomObject);
            if (save) {
                this.SAVED_SESSION_ROOMS.push(roomObject);
                app.ajax.post("/services/chat/rooms/create", {
                    name: roomObject.name,
                    type: "group",
                    object: JSON.stringify(roomObject)
                });
            }
        }
        this.addSessionRoomObjects(false);
    }

    addSessionRoomObjects(init) {
        if (init) {
            const oldData = this.loadData("sessionRoomsSaved");
            if (oldData) {
                for (let ai in oldData) {
                    this.SAVED_SESSION_ROOMS.push(oldData[ai]);
                    app.ajax.post("/services/chat/rooms/create", {
                        name: oldData[ai].name,
                        type: "group",
                        object: JSON.stringify(oldData[ai])
                    });
                }
                app.storage.remove(this.config.user.id + ":" + "sessionRoomsSaved");
            }
            if (typeof this.config.chat_rooms === "object") {
                for (let bi in this.config.chat_rooms) {
                    this.SAVED_SESSION_ROOMS.push(JSON.parse(this.config.chat_rooms[bi].object));
                }
            }
        }
        const rooms = this.SAVED_SESSION_ROOMS.concat(this.SESSION_ROOMS);
        for (let ci in rooms) {
            this.addRoomObject(rooms[ci]);
        }
    }

    leaveRoom(roomName, force) {
        if (this.JOINED_ROOMS.hasOwnProperty(roomName) || force === true) {
            this.clearPane(roomName);
            this.connectionManager.send($pres({
                to: this.getRoomJID(roomName) + '/' + this.config.user.u,
                type: 'unavailable'
            }).tree());

            jQuery('.chat#' + roomName, this.chatContainer).remove();
            delete this.JOINED_ROOMS[roomName];
            this.CURRENT_ROOM = null;
        }
    }

    joinRoom(roomName) {
        if (roomName === null || typeof roomName === "undefined" || this.CURRENT_ROOM === roomName) {
            return;
        }
        if (this.CURRENT_ROOM !== null) {
            this.leaveRoom(this.CURRENT_ROOM);
        }
        this.navIconButton("hide");
        this.setGame(roomName);
        this.loading("show");
        this.createChat(roomName);
        if (this.isPrivateRoom(roomName)) {
            const roomObject = {
                'name': roomName,
                'prettyName': this.prettifyPrivateRoom(roomName),
                'roomActive': false,
                'private': true,
                'image': '<div class="smallImage fas fa-comments"></div>',
                'owner': this.getPrivateRoomOwner(roomName)
            };
            this.addSessionRoom(roomObject, this.isPrivateRoom(roomName));
        }

        if (this.BASEROOM == null) {
            this.BASEROOM = roomName;
        }
        this.emptyUserlist();
        if (this.connectionManager.reconnected === false && !this.isPrivateRoom(roomName) && this.BASEROOM !== roomName) {
            this.clearChat(roomName);
        }
        this.JOINING_ROOM = roomName;
        this.sendPresence(roomName);
    }

    createRoom(roomName) {
        let newRoomNumber = 1;
        roomName = this.stripRoomNumber(roomName);
        while (this.AVAILABLE_ROOMS[roomName + "_" + newRoomNumber] !== undefined) {
            newRoomNumber++;
        }
        this.joinRoom(roomName + "_" + newRoomNumber);
    }

    joinNextAvailableRoom(roomName) {
        const room = this.roomFinder(roomName);
        if (room !== false) {
            this.joinRoom(room);
        } else {
            this.createRoom(roomName);
        }
    }

    isHidden(roomName) {
        if (typeof roomName === "string") {
            return roomName.indexOf("hidden_") === 0;
        }
        return false;
    }

    hasRoomObject(roomName) {
        return typeof this.AVAILABLE_ROOMS[roomName] === "object";
    }

    getRoomObject(roomName) {
        return this.AVAILABLE_ROOMS[roomName];
    }

    addRoomObject(roomObj) {
        this.AVAILABLE_ROOMS[roomObj.name] = roomObj;
    }

    showFriendsInRoomMessage(roomName) {
        let counter = 0;
        let html = "";
        if (this.isPrivateRoom(roomName)) {
            for (let username in this.USERS_IN_ROOM) {
                if (!this.Users.isMe(username) && !this.Users.isBlocked(username)) {
                    html += " <span onclick='app.chatWrapper.CegoXMPP.showUserMenu(\"" + username + "\")' class='profileLink " + this.Users._getFromCache(username).k + "' data-username='" + username + "'>" + this.capitalize(username) + "</span>, ";
                    counter++;
                }
            }
        } else {
            for (let username in this.FRIENDS_IN_ROOM) {
                if (!this.Users.isMe(username) && !this.Users.isBlocked(username)) {
                    html += " <span onclick='app.chatWrapper.CegoXMPP.showUserMenu(\"" + username + "\")' class='profileLink " + this.Users._getFromCache(username).k + "' data-username='" + username + "'>" + this.capitalize(username) + "</span>, ";
                    counter++;
                }
            }
        }
        if (counter) {
            this.addInfoMessage(this.CURRENT_ROOM, html + this.language.isAlsoInThisRoom);
        }
    }

    highlight(needle, haystack) {
        needle = '(?![^<]*>)\\b' + needle + '\\b';
        const regEx = new RegExp(needle, 'gi');
        const repl = '<span class="highlight">$&</span>';
        return haystack.replace(regEx, repl);
    }

    getMessagesObject(roomName) {
        const chat = this.getChat(roomName);
        const messages = chat.find('.messageList');
        return messages;
    }

    clearChat(roomName) {
        const messages = this.getMessagesObject(roomName);
        messages.empty();
    }

    friendRequest(username) {
        app.ajax.post(this.SETTINGS.ajaxScript.friendRequest, {"username": username});
    }

    adminAction(username, type, reason) {
        const options = {
            action: type,
            username: username,
            room: this.getRoomJID(this.CURRENT_ROOM),
            reason: reason
        };

        this.adminActions(options);

        return true;
    }

    adminActions(theOptions) {
        const defaultOptions = {
            username: this.config.user.u,
            user: this.connectionManager.getBareJID(),
            jid: this.connectionManager.getFullJID(),
            server: this.SETTINGS.roomBase + "." + this.config.domain,
            domain: this.config.domain
        };

        $.extend(true, defaultOptions, theOptions);
        app.ajax.post(this.SETTINGS.ajaxScript.chatAdmin + "/" + defaultOptions.action, defaultOptions);
    }

    escapeHTML(string) {
        const div = document.createElement("div");
        const text = document.createTextNode(string);
        div.appendChild(text);
        return div.innerHTML;
    }

    getBareJID(user) {
        return user + "@" + this.config.domain;
    }

    log(msg) {
        let lines = this.getErrorObject().stack.split("\n");
        let trace = "";
        for (let i in lines) {
            if (i > 1) {
                trace += lines[i] + "\n";
            }
        }
        Logger.error(msg, trace);
    }

    getErrorObject() {
        try {
            throw Error("")
        } catch (err) {
            return err;
        }
    }
}
